import { AchievementInfo } from "./AchievementInfoTypes";

// -----
// *** BRICK ACHIEVEMENTS ***
// -----

export const Achievement_Brick_3005_100: AchievementInfo = {
  id: "achievement_brick_3005_100",
  title: "Brick 1x1 Novice",
  description: "Collect 100 Brick 1x1",
  category: "brick",
  targetType: "specific",
  targetId: "3005",
  threshold: 100,
};

export const Achievement_Brick_3005_1000: AchievementInfo = {
  id: "achievement_brick_3005_1000",
  title: "Brick 1x1 Collector",
  description: "Collect 1,000 Brick 1x1",
  category: "brick",
  targetType: "specific",
  targetId: "3005",
  threshold: 1000,
};

export const Achievement_Brick_3005_10000: AchievementInfo = {
  id: "achievement_brick_3005_10000",
  title: "Brick 1x1 Expert",
  description: "Collect 10,000 Brick 1x1",
  category: "brick",
  targetType: "specific",
  targetId: "3005",
  threshold: 10000,
};

export const Achievement_Brick_3005_100000: AchievementInfo = {
  id: "achievement_brick_3005_100000",
  title: "Brick 1x1 Master",
  description: "Collect 100,000 Brick 1x1",
  category: "brick",
  targetType: "specific",
  targetId: "3005",
  threshold: 100000,
};

export const Achievement_Brick_3005_1000000: AchievementInfo = {
  id: "achievement_brick_3005_1000000",
  title: "Brick 1x1 Grandmaster",
  description: "Collect 1,000,000 Brick 1x1",
  category: "brick",
  targetType: "specific",
  targetId: "3005",
  threshold: 1000000,
};

export const Achievement_Brick_3004_100: AchievementInfo = {
  id: "achievement_brick_3004_100",
  title: "Brick 1x2 Novice",
  description: "Collect 100 Brick 1x2",
  category: "brick",
  targetType: "specific",
  targetId: "3004",
  threshold: 100,
};

export const Achievement_Brick_3004_1000: AchievementInfo = {
  id: "achievement_brick_3004_1000",
  title: "Brick 1x2 Collector",
  description: "Collect 1,000 Brick 1x2",
  category: "brick",
  targetType: "specific",
  targetId: "3004",
  threshold: 1000,
};

export const Achievement_Brick_3004_10000: AchievementInfo = {
  id: "achievement_brick_3004_10000",
  title: "Brick 1x2 Expert",
  description: "Collect 10,000 Brick 1x2",
  category: "brick",
  targetType: "specific",
  targetId: "3004",
  threshold: 10000,
};

export const Achievement_Brick_3004_100000: AchievementInfo = {
  id: "achievement_brick_3004_100000",
  title: "Brick 1x2 Master",
  description: "Collect 100,000 Brick 1x2",
  category: "brick",
  targetType: "specific",
  targetId: "3004",
  threshold: 100000,
};

export const Achievement_Brick_3004_1000000: AchievementInfo = {
  id: "achievement_brick_3004_1000000",
  title: "Brick 1x2 Grandmaster",
  description: "Collect 1,000,000 Brick 1x2",
  category: "brick",
  targetType: "specific",
  targetId: "3004",
  threshold: 1000000,
};

export const Achievement_Brick_3010_100: AchievementInfo = {
  id: "achievement_brick_3010_100",
  title: "Brick 1x4 Novice",
  description: "Collect 100 Brick 1x4",
  category: "brick",
  targetType: "specific",
  targetId: "3010",
  threshold: 100,
};

export const Achievement_Brick_3010_1000: AchievementInfo = {
  id: "achievement_brick_3010_1000",
  title: "Brick 1x4 Collector",
  description: "Collect 1,000 Brick 1x4",
  category: "brick",
  targetType: "specific",
  targetId: "3010",
  threshold: 1000,
};

export const Achievement_Brick_3010_10000: AchievementInfo = {
  id: "achievement_brick_3010_10000",
  title: "Brick 1x4 Expert",
  description: "Collect 10,000 Brick 1x4",
  category: "brick",
  targetType: "specific",
  targetId: "3010",
  threshold: 10000,
};

export const Achievement_Brick_3010_100000: AchievementInfo = {
  id: "achievement_brick_3010_100000",
  title: "Brick 1x4 Master",
  description: "Collect 100,000 Brick 1x4",
  category: "brick",
  targetType: "specific",
  targetId: "3010",
  threshold: 100000,
};

export const Achievement_Brick_3010_1000000: AchievementInfo = {
  id: "achievement_brick_3010_1000000",
  title: "Brick 1x4 Grandmaster",
  description: "Collect 1,000,000 Brick 1x4",
  category: "brick",
  targetType: "specific",
  targetId: "3010",
  threshold: 1000000,
};

export const Achievement_Brick_3003_100: AchievementInfo = {
  id: "achievement_brick_3003_100",
  title: "Brick 2x2 Novice",
  description: "Collect 100 Brick 2x2",
  category: "brick",
  targetType: "specific",
  targetId: "3003",
  threshold: 100,
};

export const Achievement_Brick_3003_1000: AchievementInfo = {
  id: "achievement_brick_3003_1000",
  title: "Brick 2x2 Collector",
  description: "Collect 1,000 Brick 2x2",
  category: "brick",
  targetType: "specific",
  targetId: "3003",
  threshold: 1000,
};

export const Achievement_Brick_3003_10000: AchievementInfo = {
  id: "achievement_brick_3003_10000",
  title: "Brick 2x2 Expert",
  description: "Collect 10,000 Brick 2x2",
  category: "brick",
  targetType: "specific",
  targetId: "3003",
  threshold: 10000,
};

export const Achievement_Brick_3003_100000: AchievementInfo = {
  id: "achievement_brick_3003_100000",
  title: "Brick 2x2 Master",
  description: "Collect 100,000 Brick 2x2",
  category: "brick",
  targetType: "specific",
  targetId: "3003",
  threshold: 100000,
};

export const Achievement_Brick_3003_1000000: AchievementInfo = {
  id: "achievement_brick_3003_1000000",
  title: "Brick 2x2 Grandmaster",
  description: "Collect 1,000,000 Brick 2x2",
  category: "brick",
  targetType: "specific",
  targetId: "3003",
  threshold: 1000000,
};

export const Achievement_Brick_3001_100: AchievementInfo = {
  id: "achievement_brick_3001_100",
  title: "Brick 2x4 Novice",
  description: "Collect 100 Brick 2x4",
  category: "brick",
  targetType: "specific",
  targetId: "3001",
  threshold: 100,
};

export const Achievement_Brick_3001_1000: AchievementInfo = {
  id: "achievement_brick_3001_1000",
  title: "Brick 2x4 Collector",
  description: "Collect 1,000 Brick 2x4",
  category: "brick",
  targetType: "specific",
  targetId: "3001",
  threshold: 1000,
};

export const Achievement_Brick_3001_10000: AchievementInfo = {
  id: "achievement_brick_3001_10000",
  title: "Brick 2x4 Expert",
  description: "Collect 10,000 Brick 2x4",
  category: "brick",
  targetType: "specific",
  targetId: "3001",
  threshold: 10000,
};

export const Achievement_Brick_3001_100000: AchievementInfo = {
  id: "achievement_brick_3001_100000",
  title: "Brick 2x4 Master",
  description: "Collect 100,000 Brick 2x4",
  category: "brick",
  targetType: "specific",
  targetId: "3001",
  threshold: 100000,
};

export const Achievement_Brick_3001_1000000: AchievementInfo = {
  id: "achievement_brick_3001_1000000",
  title: "Brick 2x4 Grandmaster",
  description: "Collect 1,000,000 Brick 2x4",
  category: "brick",
  targetType: "specific",
  targetId: "3001",
  threshold: 1000000,
};

export const Achievement_Brick_3024_100: AchievementInfo = {
  id: "achievement_brick_3024_100",
  title: "Plate 1x1 Novice",
  description: "Collect 100 Plate 1x1",
  category: "brick",
  targetType: "specific",
  targetId: "3024",
  threshold: 100,
};

export const Achievement_Brick_3024_1000: AchievementInfo = {
  id: "achievement_brick_3024_1000",
  title: "Plate 1x1 Collector",
  description: "Collect 1,000 Plate 1x1",
  category: "brick",
  targetType: "specific",
  targetId: "3024",
  threshold: 1000,
};

export const Achievement_Brick_3024_10000: AchievementInfo = {
  id: "achievement_brick_3024_10000",
  title: "Plate 1x1 Expert",
  description: "Collect 10,000 Plate 1x1",
  category: "brick",
  targetType: "specific",
  targetId: "3024",
  threshold: 10000,
};

export const Achievement_Brick_3024_100000: AchievementInfo = {
  id: "achievement_brick_3024_100000",
  title: "Plate 1x1 Master",
  description: "Collect 100,000 Plate 1x1",
  category: "brick",
  targetType: "specific",
  targetId: "3024",
  threshold: 100000,
};

export const Achievement_Brick_3024_1000000: AchievementInfo = {
  id: "achievement_brick_3024_1000000",
  title: "Plate 1x1 Grandmaster",
  description: "Collect 1,000,000 Plate 1x1",
  category: "brick",
  targetType: "specific",
  targetId: "3024",
  threshold: 1000000,
};

export const Achievement_Brick_3023_100: AchievementInfo = {
  id: "achievement_brick_3023_100",
  title: "Plate 1x2 Novice",
  description: "Collect 100 Plate 1x2",
  category: "brick",
  targetType: "specific",
  targetId: "3023",
  threshold: 100,
};

export const Achievement_Brick_3023_1000: AchievementInfo = {
  id: "achievement_brick_3023_1000",
  title: "Plate 1x2 Collector",
  description: "Collect 1,000 Plate 1x2",
  category: "brick",
  targetType: "specific",
  targetId: "3023",
  threshold: 1000,
};

export const Achievement_Brick_3023_10000: AchievementInfo = {
  id: "achievement_brick_3023_10000",
  title: "Plate 1x2 Expert",
  description: "Collect 10,000 Plate 1x2",
  category: "brick",
  targetType: "specific",
  targetId: "3023",
  threshold: 10000,
};

export const Achievement_Brick_3023_100000: AchievementInfo = {
  id: "achievement_brick_3023_100000",
  title: "Plate 1x2 Master",
  description: "Collect 100,000 Plate 1x2",
  category: "brick",
  targetType: "specific",
  targetId: "3023",
  threshold: 100000,
};

export const Achievement_Brick_3023_1000000: AchievementInfo = {
  id: "achievement_brick_3023_1000000",
  title: "Plate 1x2 Grandmaster",
  description: "Collect 1,000,000 Plate 1x2",
  category: "brick",
  targetType: "specific",
  targetId: "3023",
  threshold: 1000000,
};

export const Achievement_Brick_3710_100: AchievementInfo = {
  id: "achievement_brick_3710_100",
  title: "Plate 1x4 Novice",
  description: "Collect 100 Plate 1x4",
  category: "brick",
  targetType: "specific",
  targetId: "3710",
  threshold: 100,
};

export const Achievement_Brick_3710_1000: AchievementInfo = {
  id: "achievement_brick_3710_1000",
  title: "Plate 1x4 Collector",
  description: "Collect 1,000 Plate 1x4",
  category: "brick",
  targetType: "specific",
  targetId: "3710",
  threshold: 1000,
};

export const Achievement_Brick_3710_10000: AchievementInfo = {
  id: "achievement_brick_3710_10000",
  title: "Plate 1x4 Expert",
  description: "Collect 10,000 Plate 1x4",
  category: "brick",
  targetType: "specific",
  targetId: "3710",
  threshold: 10000,
};

export const Achievement_Brick_3710_100000: AchievementInfo = {
  id: "achievement_brick_3710_100000",
  title: "Plate 1x4 Master",
  description: "Collect 100,000 Plate 1x4",
  category: "brick",
  targetType: "specific",
  targetId: "3710",
  threshold: 100000,
};

export const Achievement_Brick_3710_1000000: AchievementInfo = {
  id: "achievement_brick_3710_1000000",
  title: "Plate 1x4 Grandmaster",
  description: "Collect 1,000,000 Plate 1x4",
  category: "brick",
  targetType: "specific",
  targetId: "3710",
  threshold: 1000000,
};

export const Achievement_Brick_3022_100: AchievementInfo = {
  id: "achievement_brick_3022_100",
  title: "Plate 2x2 Novice",
  description: "Collect 100 Plate 2x2",
  category: "brick",
  targetType: "specific",
  targetId: "3022",
  threshold: 100,
};

export const Achievement_Brick_3022_1000: AchievementInfo = {
  id: "achievement_brick_3022_1000",
  title: "Plate 2x2 Collector",
  description: "Collect 1,000 Plate 2x2",
  category: "brick",
  targetType: "specific",
  targetId: "3022",
  threshold: 1000,
};

export const Achievement_Brick_3022_10000: AchievementInfo = {
  id: "achievement_brick_3022_10000",
  title: "Plate 2x2 Expert",
  description: "Collect 10,000 Plate 2x2",
  category: "brick",
  targetType: "specific",
  targetId: "3022",
  threshold: 10000,
};

export const Achievement_Brick_3022_100000: AchievementInfo = {
  id: "achievement_brick_3022_100000",
  title: "Plate 2x2 Master",
  description: "Collect 100,000 Plate 2x2",
  category: "brick",
  targetType: "specific",
  targetId: "3022",
  threshold: 100000,
};

export const Achievement_Brick_3022_1000000: AchievementInfo = {
  id: "achievement_brick_3022_1000000",
  title: "Plate 2x2 Grandmaster",
  description: "Collect 1,000,000 Plate 2x2",
  category: "brick",
  targetType: "specific",
  targetId: "3022",
  threshold: 1000000,
};

export const Achievement_Brick_3020_100: AchievementInfo = {
  id: "achievement_brick_3020_100",
  title: "Plate 2x4 Novice",
  description: "Collect 100 Plate 2x4",
  category: "brick",
  targetType: "specific",
  targetId: "3020",
  threshold: 100,
};

export const Achievement_Brick_3020_1000: AchievementInfo = {
  id: "achievement_brick_3020_1000",
  title: "Plate 2x4 Collector",
  description: "Collect 1,000 Plate 2x4",
  category: "brick",
  targetType: "specific",
  targetId: "3020",
  threshold: 1000,
};

export const Achievement_Brick_3020_10000: AchievementInfo = {
  id: "achievement_brick_3020_10000",
  title: "Plate 2x4 Expert",
  description: "Collect 10,000 Plate 2x4",
  category: "brick",
  targetType: "specific",
  targetId: "3020",
  threshold: 10000,
};

export const Achievement_Brick_3020_100000: AchievementInfo = {
  id: "achievement_brick_3020_100000",
  title: "Plate 2x4 Master",
  description: "Collect 100,000 Plate 2x4",
  category: "brick",
  targetType: "specific",
  targetId: "3020",
  threshold: 100000,
};

export const Achievement_Brick_3020_1000000: AchievementInfo = {
  id: "achievement_brick_3020_1000000",
  title: "Plate 2x4 Grandmaster",
  description: "Collect 1,000,000 Plate 2x4",
  category: "brick",
  targetType: "specific",
  targetId: "3020",
  threshold: 1000000,
};

export const Achievement_Brick_54200_100: AchievementInfo = {
  id: "achievement_brick_54200_100",
  title: "Slope 1x1 Novice",
  description: "Collect 100 Slope 1x1",
  category: "brick",
  targetType: "specific",
  targetId: "54200",
  threshold: 100,
};

export const Achievement_Brick_54200_1000: AchievementInfo = {
  id: "achievement_brick_54200_1000",
  title: "Slope 1x1 Collector",
  description: "Collect 1,000 Slope 1x1",
  category: "brick",
  targetType: "specific",
  targetId: "54200",
  threshold: 1000,
};

export const Achievement_Brick_54200_10000: AchievementInfo = {
  id: "achievement_brick_54200_10000",
  title: "Slope 1x1 Expert",
  description: "Collect 10,000 Slope 1x1",
  category: "brick",
  targetType: "specific",
  targetId: "54200",
  threshold: 10000,
};

export const Achievement_Brick_54200_50000: AchievementInfo = {
  id: "achievement_brick_54200_50000",
  title: "Slope 1x1 Master",
  description: "Collect 50,000 Slope 1x1",
  category: "brick",
  targetType: "specific",
  targetId: "54200",
  threshold: 50000,
};

export const Achievement_Brick_3040_100: AchievementInfo = {
  id: "achievement_brick_3040_100",
  title: "Slope 2x1 Novice",
  description: "Collect 100 Slope 2x1",
  category: "brick",
  targetType: "specific",
  targetId: "3040",
  threshold: 100,
};

export const Achievement_Brick_3040_1000: AchievementInfo = {
  id: "achievement_brick_3040_1000",
  title: "Slope 2x1 Collector",
  description: "Collect 1,000 Slope 2x1",
  category: "brick",
  targetType: "specific",
  targetId: "3040",
  threshold: 1000,
};

export const Achievement_Brick_3040_10000: AchievementInfo = {
  id: "achievement_brick_3040_10000",
  title: "Slope 2x1 Expert",
  description: "Collect 10,000 Slope 2x1",
  category: "brick",
  targetType: "specific",
  targetId: "3040",
  threshold: 10000,
};

export const Achievement_Brick_3040_50000: AchievementInfo = {
  id: "achievement_brick_3040_50000",
  title: "Slope 2x1 Master",
  description: "Collect 50,000 Slope 2x1",
  category: "brick",
  targetType: "specific",
  targetId: "3040",
  threshold: 50000,
};

export const Achievement_Brick_4286_100: AchievementInfo = {
  id: "achievement_brick_4286_100",
  title: "Slope 3x1 Novice",
  description: "Collect 100 Slope 3x1",
  category: "brick",
  targetType: "specific",
  targetId: "4286",
  threshold: 100,
};

export const Achievement_Brick_4286_1000: AchievementInfo = {
  id: "achievement_brick_4286_1000",
  title: "Slope 3x1 Collector",
  description: "Collect 1,000 Slope 3x1",
  category: "brick",
  targetType: "specific",
  targetId: "4286",
  threshold: 1000,
};

export const Achievement_Brick_4286_10000: AchievementInfo = {
  id: "achievement_brick_4286_10000",
  title: "Slope 3x1 Expert",
  description: "Collect 10,000 Slope 3x1",
  category: "brick",
  targetType: "specific",
  targetId: "4286",
  threshold: 10000,
};

export const Achievement_Brick_4286_50000: AchievementInfo = {
  id: "achievement_brick_4286_50000",
  title: "Slope 3x1 Master",
  description: "Collect 50,000 Slope 3x1",
  category: "brick",
  targetType: "specific",
  targetId: "4286",
  threshold: 50000,
};

export const Achievement_Brick_60477_100: AchievementInfo = {
  id: "achievement_brick_60477_100",
  title: "Slope 4x1 Novice",
  description: "Collect 100 Slope 4x1",
  category: "brick",
  targetType: "specific",
  targetId: "60477",
  threshold: 100,
};

export const Achievement_Brick_60477_1000: AchievementInfo = {
  id: "achievement_brick_60477_1000",
  title: "Slope 4x1 Collector",
  description: "Collect 1,000 Slope 4x1",
  category: "brick",
  targetType: "specific",
  targetId: "60477",
  threshold: 1000,
};

export const Achievement_Brick_60477_10000: AchievementInfo = {
  id: "achievement_brick_60477_10000",
  title: "Slope 4x1 Expert",
  description: "Collect 10,000 Slope 4x1",
  category: "brick",
  targetType: "specific",
  targetId: "60477",
  threshold: 10000,
};

export const Achievement_Brick_60477_50000: AchievementInfo = {
  id: "achievement_brick_60477_50000",
  title: "Slope 4x1 Master",
  description: "Collect 50,000 Slope 4x1",
  category: "brick",
  targetType: "specific",
  targetId: "60477",
  threshold: 50000,
};

export const Achievement_Brick_3039_100: AchievementInfo = {
  id: "achievement_brick_3039_100",
  title: "Slope 2x2 Novice",
  description: "Collect 100 Slope 2x2",
  category: "brick",
  targetType: "specific",
  targetId: "3039",
  threshold: 100,
};

export const Achievement_Brick_3039_1000: AchievementInfo = {
  id: "achievement_brick_3039_1000",
  title: "Slope 2x2 Collector",
  description: "Collect 1,000 Slope 2x2",
  category: "brick",
  targetType: "specific",
  targetId: "3039",
  threshold: 1000,
};

export const Achievement_Brick_3039_10000: AchievementInfo = {
  id: "achievement_brick_3039_10000",
  title: "Slope 2x2 Expert",
  description: "Collect 10,000 Slope 2x2",
  category: "brick",
  targetType: "specific",
  targetId: "3039",
  threshold: 10000,
};

export const Achievement_Brick_3039_50000: AchievementInfo = {
  id: "achievement_brick_3039_50000",
  title: "Slope 2x2 Master",
  description: "Collect 50,000 Slope 2x2",
  category: "brick",
  targetType: "specific",
  targetId: "3039",
  threshold: 50000,
};

export const Achievement_Brick_30363_100: AchievementInfo = {
  id: "achievement_brick_30363_100",
  title: "Slope 4x2 Novice",
  description: "Collect 100 Slope 4x2",
  category: "brick",
  targetType: "specific",
  targetId: "30363",
  threshold: 100,
};

export const Achievement_Brick_30363_1000: AchievementInfo = {
  id: "achievement_brick_30363_1000",
  title: "Slope 4x2 Collector",
  description: "Collect 1,000 Slope 4x2",
  category: "brick",
  targetType: "specific",
  targetId: "30363",
  threshold: 1000,
};

export const Achievement_Brick_30363_10000: AchievementInfo = {
  id: "achievement_brick_30363_10000",
  title: "Slope 4x2 Expert",
  description: "Collect 10,000 Slope 4x2",
  category: "brick",
  targetType: "specific",
  targetId: "30363",
  threshold: 10000,
};

export const Achievement_Brick_30363_50000: AchievementInfo = {
  id: "achievement_brick_30363_50000",
  title: "Slope 4x2 Master",
  description: "Collect 50,000 Slope 4x2",
  category: "brick",
  targetType: "specific",
  targetId: "30363",
  threshold: 50000,
};

export const Achievement_Brick_3660_100: AchievementInfo = {
  id: "achievement_brick_3660_100",
  title: "Inverted Slope 2x2 Novice",
  description: "Collect 100 Inverted Slope 2x2",
  category: "brick",
  targetType: "specific",
  targetId: "3660",
  threshold: 100,
};

export const Achievement_Brick_3660_1000: AchievementInfo = {
  id: "achievement_brick_3660_1000",
  title: "Inverted Slope 2x2 Collector",
  description: "Collect 1,000 Inverted Slope 2x2",
  category: "brick",
  targetType: "specific",
  targetId: "3660",
  threshold: 1000,
};

export const Achievement_Brick_3660_10000: AchievementInfo = {
  id: "achievement_brick_3660_10000",
  title: "Inverted Slope 2x2 Expert",
  description: "Collect 10,000 Inverted Slope 2x2",
  category: "brick",
  targetType: "specific",
  targetId: "3660",
  threshold: 10000,
};

export const Achievement_Brick_3660_50000: AchievementInfo = {
  id: "achievement_brick_3660_50000",
  title: "Inverted Slope 2x2 Master",
  description: "Collect 50,000 Inverted Slope 2x2",
  category: "brick",
  targetType: "specific",
  targetId: "3660",
  threshold: 50000,
};

export const Achievement_Brick_2752_100: AchievementInfo = {
  id: "achievement_brick_2752_100",
  title: "Inverted Slope 3x2 Novice",
  description: "Collect 100 Inverted Slope 3x2",
  category: "brick",
  targetType: "specific",
  targetId: "2752",
  threshold: 100,
};

export const Achievement_Brick_2752_1000: AchievementInfo = {
  id: "achievement_brick_2752_1000",
  title: "Inverted Slope 3x2 Collector",
  description: "Collect 1,000 Inverted Slope 3x2",
  category: "brick",
  targetType: "specific",
  targetId: "2752",
  threshold: 1000,
};

export const Achievement_Brick_2752_10000: AchievementInfo = {
  id: "achievement_brick_2752_10000",
  title: "Inverted Slope 3x2 Expert",
  description: "Collect 10,000 Inverted Slope 3x2",
  category: "brick",
  targetType: "specific",
  targetId: "2752",
  threshold: 10000,
};

export const Achievement_Brick_2752_50000: AchievementInfo = {
  id: "achievement_brick_2752_50000",
  title: "Inverted Slope 3x2 Master",
  description: "Collect 50,000 Inverted Slope 3x2",
  category: "brick",
  targetType: "specific",
  targetId: "2752",
  threshold: 50000,
};

export const Achievement_Brick_30390_100: AchievementInfo = {
  id: "achievement_brick_30390_100",
  title: "Inverted Slope 4x2 Novice",
  description: "Collect 100 Inverted Slope 4x2",
  category: "brick",
  targetType: "specific",
  targetId: "30390",
  threshold: 100,
};

export const Achievement_Brick_30390_1000: AchievementInfo = {
  id: "achievement_brick_30390_1000",
  title: "Inverted Slope 4x2 Collector",
  description: "Collect 1,000 Inverted Slope 4x2",
  category: "brick",
  targetType: "specific",
  targetId: "30390",
  threshold: 1000,
};

export const Achievement_Brick_30390_10000: AchievementInfo = {
  id: "achievement_brick_30390_10000",
  title: "Inverted Slope 4x2 Expert",
  description: "Collect 10,000 Inverted Slope 4x2",
  category: "brick",
  targetType: "specific",
  targetId: "30390",
  threshold: 10000,
};

export const Achievement_Brick_30390_50000: AchievementInfo = {
  id: "achievement_brick_30390_50000",
  title: "Inverted Slope 4x2 Master",
  description: "Collect 50,000 Inverted Slope 4x2",
  category: "brick",
  targetType: "specific",
  targetId: "30390",
  threshold: 50000,
};

export const Achievement_Brick_6091_100: AchievementInfo = {
  id: "achievement_brick_6091_100",
  title: "Curved Slope 2x1 Novice",
  description: "Collect 100 Curved Slope 2x1",
  category: "brick",
  targetType: "specific",
  targetId: "6091",
  threshold: 100,
};

export const Achievement_Brick_6091_1000: AchievementInfo = {
  id: "achievement_brick_6091_1000",
  title: "Curved Slope 2x1 Collector",
  description: "Collect 1,000 Curved Slope 2x1",
  category: "brick",
  targetType: "specific",
  targetId: "6091",
  threshold: 1000,
};

export const Achievement_Brick_6091_10000: AchievementInfo = {
  id: "achievement_brick_6091_10000",
  title: "Curved Slope 2x1 Expert",
  description: "Collect 10,000 Curved Slope 2x1",
  category: "brick",
  targetType: "specific",
  targetId: "6091",
  threshold: 10000,
};

export const Achievement_Brick_6091_50000: AchievementInfo = {
  id: "achievement_brick_6091_50000",
  title: "Curved Slope 2x1 Master",
  description: "Collect 50,000 Curved Slope 2x1",
  category: "brick",
  targetType: "specific",
  targetId: "6091",
  threshold: 50000,
};

export const Achievement_Brick_4349_100: AchievementInfo = {
  id: "achievement_brick_4349_100",
  title: "Megaphone Novice",
  description: "Collect 100 Megaphone",
  category: "brick",
  targetType: "specific",
  targetId: "4349",
  threshold: 100,
};

export const Achievement_Brick_4349_1000: AchievementInfo = {
  id: "achievement_brick_4349_1000",
  title: "Megaphone Collector",
  description: "Collect 1,000 Megaphone",
  category: "brick",
  targetType: "specific",
  targetId: "4349",
  threshold: 1000,
};

export const Achievement_Brick_4349_10000: AchievementInfo = {
  id: "achievement_brick_4349_10000",
  title: "Megaphone Expert",
  description: "Collect 10,000 Megaphone",
  category: "brick",
  targetType: "specific",
  targetId: "4349",
  threshold: 10000,
};

export const Achievement_Brick_4349_50000: AchievementInfo = {
  id: "achievement_brick_4349_50000",
  title: "Megaphone Master",
  description: "Collect 50,000 Megaphone",
  category: "brick",
  targetType: "specific",
  targetId: "4349",
  threshold: 50000,
};

export const Achievement_Brick_30162_100: AchievementInfo = {
  id: "achievement_brick_30162_100",
  title: "Binoculars Novice",
  description: "Collect 100 Binoculars",
  category: "brick",
  targetType: "specific",
  targetId: "30162",
  threshold: 100,
};

export const Achievement_Brick_30162_1000: AchievementInfo = {
  id: "achievement_brick_30162_1000",
  title: "Binoculars Collector",
  description: "Collect 1,000 Binoculars",
  category: "brick",
  targetType: "specific",
  targetId: "30162",
  threshold: 1000,
};

export const Achievement_Brick_30162_10000: AchievementInfo = {
  id: "achievement_brick_30162_10000",
  title: "Binoculars Expert",
  description: "Collect 10,000 Binoculars",
  category: "brick",
  targetType: "specific",
  targetId: "30162",
  threshold: 10000,
};

export const Achievement_Brick_30162_50000: AchievementInfo = {
  id: "achievement_brick_30162_50000",
  title: "Binoculars Master",
  description: "Collect 50,000 Binoculars",
  category: "brick",
  targetType: "specific",
  targetId: "30162",
  threshold: 50000,
};

export const Achievement_Brick_30228_100: AchievementInfo = {
  id: "achievement_brick_30228_100",
  title: "Jackhammer Novice",
  description: "Collect 100 Jackhammer",
  category: "brick",
  targetType: "specific",
  targetId: "30228",
  threshold: 100,
};

export const Achievement_Brick_30228_1000: AchievementInfo = {
  id: "achievement_brick_30228_1000",
  title: "Jackhammer Collector",
  description: "Collect 1,000 Jackhammer",
  category: "brick",
  targetType: "specific",
  targetId: "30228",
  threshold: 1000,
};

export const Achievement_Brick_30228_10000: AchievementInfo = {
  id: "achievement_brick_30228_10000",
  title: "Jackhammer Expert",
  description: "Collect 10,000 Jackhammer",
  category: "brick",
  targetType: "specific",
  targetId: "30228",
  threshold: 10000,
};

export const Achievement_Brick_30228_50000: AchievementInfo = {
  id: "achievement_brick_30228_50000",
  title: "Jackhammer Master",
  description: "Collect 50,000 Jackhammer",
  category: "brick",
  targetType: "specific",
  targetId: "30228",
  threshold: 50000,
};

export const Achievement_Brick_6246a_100: AchievementInfo = {
  id: "achievement_brick_6246a_100",
  title: "Chisel Novice",
  description: "Collect 100 Chisel",
  category: "brick",
  targetType: "specific",
  targetId: "6246a",
  threshold: 100,
};

export const Achievement_Brick_6246a_1000: AchievementInfo = {
  id: "achievement_brick_6246a_1000",
  title: "Chisel Collector",
  description: "Collect 1,000 Chisel",
  category: "brick",
  targetType: "specific",
  targetId: "6246a",
  threshold: 1000,
};

export const Achievement_Brick_6246a_10000: AchievementInfo = {
  id: "achievement_brick_6246a_10000",
  title: "Chisel Expert",
  description: "Collect 10,000 Chisel",
  category: "brick",
  targetType: "specific",
  targetId: "6246a",
  threshold: 10000,
};

export const Achievement_Brick_6246a_50000: AchievementInfo = {
  id: "achievement_brick_6246a_50000",
  title: "Chisel Master",
  description: "Collect 50,000 Chisel",
  category: "brick",
  targetType: "specific",
  targetId: "6246a",
  threshold: 50000,
};

export const Achievement_Brick_30148_100: AchievementInfo = {
  id: "achievement_brick_30148_100",
  title: "Movie Camera Novice",
  description: "Collect 100 Movie Camera",
  category: "brick",
  targetType: "specific",
  targetId: "30148",
  threshold: 100,
};

export const Achievement_Brick_30148_1000: AchievementInfo = {
  id: "achievement_brick_30148_1000",
  title: "Movie Camera Collector",
  description: "Collect 1,000 Movie Camera",
  category: "brick",
  targetType: "specific",
  targetId: "30148",
  threshold: 1000,
};

export const Achievement_Brick_30148_10000: AchievementInfo = {
  id: "achievement_brick_30148_10000",
  title: "Movie Camera Expert",
  description: "Collect 10,000 Movie Camera",
  category: "brick",
  targetType: "specific",
  targetId: "30148",
  threshold: 10000,
};

export const Achievement_Brick_30148_50000: AchievementInfo = {
  id: "achievement_brick_30148_50000",
  title: "Movie Camera Master",
  description: "Collect 50,000 Movie Camera",
  category: "brick",
  targetType: "specific",
  targetId: "30148",
  threshold: 50000,
};

export const Achievement_Brick_93106_100: AchievementInfo = {
  id: "achievement_brick_93106_100",
  title: "Metal Detector Novice",
  description: "Collect 100 Metal Detector",
  category: "brick",
  targetType: "specific",
  targetId: "93106",
  threshold: 100,
};

export const Achievement_Brick_93106_1000: AchievementInfo = {
  id: "achievement_brick_93106_1000",
  title: "Metal Detector Collector",
  description: "Collect 1,000 Metal Detector",
  category: "brick",
  targetType: "specific",
  targetId: "93106",
  threshold: 1000,
};

export const Achievement_Brick_93106_10000: AchievementInfo = {
  id: "achievement_brick_93106_10000",
  title: "Metal Detector Expert",
  description: "Collect 10,000 Metal Detector",
  category: "brick",
  targetType: "specific",
  targetId: "93106",
  threshold: 10000,
};

export const Achievement_Brick_93106_50000: AchievementInfo = {
  id: "achievement_brick_93106_50000",
  title: "Metal Detector Master",
  description: "Collect 50,000 Metal Detector",
  category: "brick",
  targetType: "specific",
  targetId: "93106",
  threshold: 50000,
};

export const Achievement_Brick_4449_100: AchievementInfo = {
  id: "achievement_brick_4449_100",
  title: "Suitcase Novice",
  description: "Collect 100 Suitcase",
  category: "brick",
  targetType: "specific",
  targetId: "4449",
  threshold: 100,
};

export const Achievement_Brick_4449_1000: AchievementInfo = {
  id: "achievement_brick_4449_1000",
  title: "Suitcase Collector",
  description: "Collect 1,000 Suitcase",
  category: "brick",
  targetType: "specific",
  targetId: "4449",
  threshold: 1000,
};

export const Achievement_Brick_4449_10000: AchievementInfo = {
  id: "achievement_brick_4449_10000",
  title: "Suitcase Expert",
  description: "Collect 10,000 Suitcase",
  category: "brick",
  targetType: "specific",
  targetId: "4449",
  threshold: 10000,
};

export const Achievement_Brick_4449_50000: AchievementInfo = {
  id: "achievement_brick_4449_50000",
  title: "Suitcase Master",
  description: "Collect 50,000 Suitcase",
  category: "brick",
  targetType: "specific",
  targetId: "4449",
  threshold: 50000,
};

export const Achievement_Brick_30304_100: AchievementInfo = {
  id: "achievement_brick_30304_100",
  title: "Space Binoculars Novice",
  description: "Collect 100 Space Binoculars",
  category: "brick",
  targetType: "specific",
  targetId: "30304",
  threshold: 100,
};

export const Achievement_Brick_30304_1000: AchievementInfo = {
  id: "achievement_brick_30304_1000",
  title: "Space Binoculars Collector",
  description: "Collect 1,000 Space Binoculars",
  category: "brick",
  targetType: "specific",
  targetId: "30304",
  threshold: 1000,
};

export const Achievement_Brick_30304_10000: AchievementInfo = {
  id: "achievement_brick_30304_10000",
  title: "Space Binoculars Expert",
  description: "Collect 10,000 Space Binoculars",
  category: "brick",
  targetType: "specific",
  targetId: "30304",
  threshold: 10000,
};

export const Achievement_Brick_30304_50000: AchievementInfo = {
  id: "achievement_brick_30304_50000",
  title: "Space Binoculars Master",
  description: "Collect 50,000 Space Binoculars",
  category: "brick",
  targetType: "specific",
  targetId: "30304",
  threshold: 50000,
};

export const Achievement_Brick_3962a_100: AchievementInfo = {
  id: "achievement_brick_3962a_100",
  title: "Walkie Talkie Novice",
  description: "Collect 100 Walkie Talkie",
  category: "brick",
  targetType: "specific",
  targetId: "3962a",
  threshold: 100,
};

export const Achievement_Brick_3962a_1000: AchievementInfo = {
  id: "achievement_brick_3962a_1000",
  title: "Walkie Talkie Collector",
  description: "Collect 1,000 Walkie Talkie",
  category: "brick",
  targetType: "specific",
  targetId: "3962a",
  threshold: 1000,
};

export const Achievement_Brick_3962a_10000: AchievementInfo = {
  id: "achievement_brick_3962a_10000",
  title: "Walkie Talkie Expert",
  description: "Collect 10,000 Walkie Talkie",
  category: "brick",
  targetType: "specific",
  targetId: "3962a",
  threshold: 10000,
};

export const Achievement_Brick_3962a_50000: AchievementInfo = {
  id: "achievement_brick_3962a_50000",
  title: "Walkie Talkie Master",
  description: "Collect 50,000 Walkie Talkie",
  category: "brick",
  targetType: "specific",
  targetId: "3962a",
  threshold: 50000,
};

export const Achievement_Brick_3835_100: AchievementInfo = {
  id: "achievement_brick_3835_100",
  title: "Mini Axe Novice",
  description: "Collect 100 Mini Axe",
  category: "brick",
  targetType: "specific",
  targetId: "3835",
  threshold: 100,
};

export const Achievement_Brick_3835_1000: AchievementInfo = {
  id: "achievement_brick_3835_1000",
  title: "Mini Axe Collector",
  description: "Collect 1,000 Mini Axe",
  category: "brick",
  targetType: "specific",
  targetId: "3835",
  threshold: 1000,
};

export const Achievement_Brick_3835_10000: AchievementInfo = {
  id: "achievement_brick_3835_10000",
  title: "Mini Axe Expert",
  description: "Collect 10,000 Mini Axe",
  category: "brick",
  targetType: "specific",
  targetId: "3835",
  threshold: 10000,
};

export const Achievement_Brick_3835_50000: AchievementInfo = {
  id: "achievement_brick_3835_50000",
  title: "Mini Axe Master",
  description: "Collect 50,000 Mini Axe",
  category: "brick",
  targetType: "specific",
  targetId: "3835",
  threshold: 50000,
};

export const Achievement_Brick_54271_100: AchievementInfo = {
  id: "achievement_brick_54271_100",
  title: "Sphere Holder Novice",
  description: "Collect 100 Sphere Holder",
  category: "brick",
  targetType: "specific",
  targetId: "54271",
  threshold: 100,
};

export const Achievement_Brick_54271_1000: AchievementInfo = {
  id: "achievement_brick_54271_1000",
  title: "Sphere Holder Collector",
  description: "Collect 1,000 Sphere Holder",
  category: "brick",
  targetType: "specific",
  targetId: "54271",
  threshold: 1000,
};

export const Achievement_Brick_54271_10000: AchievementInfo = {
  id: "achievement_brick_54271_10000",
  title: "Sphere Holder Expert",
  description: "Collect 10,000 Sphere Holder",
  category: "brick",
  targetType: "specific",
  targetId: "54271",
  threshold: 10000,
};

export const Achievement_Brick_54271_50000: AchievementInfo = {
  id: "achievement_brick_54271_50000",
  title: "Sphere Holder Master",
  description: "Collect 50,000 Sphere Holder",
  category: "brick",
  targetType: "specific",
  targetId: "54271",
  threshold: 50000,
};

export const Achievement_Brick_42042_100: AchievementInfo = {
  id: "achievement_brick_42042_100",
  title: "Krana Holder Novice",
  description: "Collect 100 Krana Holder",
  category: "brick",
  targetType: "specific",
  targetId: "42042",
  threshold: 100,
};

export const Achievement_Brick_42042_1000: AchievementInfo = {
  id: "achievement_brick_42042_1000",
  title: "Krana Holder Collector",
  description: "Collect 1,000 Krana Holder",
  category: "brick",
  targetType: "specific",
  targetId: "42042",
  threshold: 1000,
};

export const Achievement_Brick_42042_10000: AchievementInfo = {
  id: "achievement_brick_42042_10000",
  title: "Krana Holder Expert",
  description: "Collect 10,000 Krana Holder",
  category: "brick",
  targetType: "specific",
  targetId: "42042",
  threshold: 10000,
};

export const Achievement_Brick_42042_50000: AchievementInfo = {
  id: "achievement_brick_42042_50000",
  title: "Krana Holder Master",
  description: "Collect 50,000 Krana Holder",
  category: "brick",
  targetType: "specific",
  targetId: "42042",
  threshold: 50000,
};

export const Achievement_Brick_32553_100: AchievementInfo = {
  id: "achievement_brick_32553_100",
  title: "Bionicle Head Novice",
  description: "Collect 100 Bionicle Head",
  category: "brick",
  targetType: "specific",
  targetId: "32553",
  threshold: 100,
};

export const Achievement_Brick_32553_1000: AchievementInfo = {
  id: "achievement_brick_32553_1000",
  title: "Bionicle Head Collector",
  description: "Collect 1,000 Bionicle Head",
  category: "brick",
  targetType: "specific",
  targetId: "32553",
  threshold: 1000,
};

export const Achievement_Brick_32553_10000: AchievementInfo = {
  id: "achievement_brick_32553_10000",
  title: "Bionicle Head Expert",
  description: "Collect 10,000 Bionicle Head",
  category: "brick",
  targetType: "specific",
  targetId: "32553",
  threshold: 10000,
};

export const Achievement_Brick_32553_50000: AchievementInfo = {
  id: "achievement_brick_32553_50000",
  title: "Bionicle Head Master",
  description: "Collect 50,000 Bionicle Head",
  category: "brick",
  targetType: "specific",
  targetId: "32553",
  threshold: 50000,
};

export const Achievement_Brick_47298_100: AchievementInfo = {
  id: "achievement_brick_47298_100",
  title: "Toa Metru Foot Novice",
  description: "Collect 100 Toa Metru Foot",
  category: "brick",
  targetType: "specific",
  targetId: "47298",
  threshold: 100,
};

export const Achievement_Brick_47298_1000: AchievementInfo = {
  id: "achievement_brick_47298_1000",
  title: "Toa Metru Foot Collector",
  description: "Collect 1,000 Toa Metru Foot",
  category: "brick",
  targetType: "specific",
  targetId: "47298",
  threshold: 1000,
};

export const Achievement_Brick_47298_10000: AchievementInfo = {
  id: "achievement_brick_47298_10000",
  title: "Toa Metru Foot Expert",
  description: "Collect 10,000 Toa Metru Foot",
  category: "brick",
  targetType: "specific",
  targetId: "47298",
  threshold: 10000,
};

export const Achievement_Brick_47298_50000: AchievementInfo = {
  id: "achievement_brick_47298_50000",
  title: "Toa Metru Foot Master",
  description: "Collect 50,000 Toa Metru Foot",
  category: "brick",
  targetType: "specific",
  targetId: "47298",
  threshold: 50000,
};

export const Achievement_Brick_41671_100: AchievementInfo = {
  id: "achievement_brick_41671_100",
  title: "Bohrok Windscreen Novice",
  description: "Collect 100 Bohrok Windscreen",
  category: "brick",
  targetType: "specific",
  targetId: "41671",
  threshold: 100,
};

export const Achievement_Brick_41671_1000: AchievementInfo = {
  id: "achievement_brick_41671_1000",
  title: "Bohrok Windscreen Collector",
  description: "Collect 1,000 Bohrok Windscreen",
  category: "brick",
  targetType: "specific",
  targetId: "41671",
  threshold: 1000,
};

export const Achievement_Brick_41671_10000: AchievementInfo = {
  id: "achievement_brick_41671_10000",
  title: "Bohrok Windscreen Expert",
  description: "Collect 10,000 Bohrok Windscreen",
  category: "brick",
  targetType: "specific",
  targetId: "41671",
  threshold: 10000,
};

export const Achievement_Brick_41671_50000: AchievementInfo = {
  id: "achievement_brick_41671_50000",
  title: "Bohrok Windscreen Master",
  description: "Collect 50,000 Bohrok Windscreen",
  category: "brick",
  targetType: "specific",
  targetId: "41671",
  threshold: 50000,
};

export const Achievement_Brick_43558_100: AchievementInfo = {
  id: "achievement_brick_43558_100",
  title: "Nuva Chest Armor Novice",
  description: "Collect 100 Nuva Chest Armor",
  category: "brick",
  targetType: "specific",
  targetId: "43558",
  threshold: 100,
};

export const Achievement_Brick_43558_1000: AchievementInfo = {
  id: "achievement_brick_43558_1000",
  title: "Nuva Chest Armor Collector",
  description: "Collect 1,000 Nuva Chest Armor",
  category: "brick",
  targetType: "specific",
  targetId: "43558",
  threshold: 1000,
};

export const Achievement_Brick_43558_10000: AchievementInfo = {
  id: "achievement_brick_43558_10000",
  title: "Nuva Chest Armor Expert",
  description: "Collect 10,000 Nuva Chest Armor",
  category: "brick",
  targetType: "specific",
  targetId: "43558",
  threshold: 10000,
};

export const Achievement_Brick_43558_50000: AchievementInfo = {
  id: "achievement_brick_43558_50000",
  title: "Nuva Chest Armor Master",
  description: "Collect 50,000 Nuva Chest Armor",
  category: "brick",
  targetType: "specific",
  targetId: "43558",
  threshold: 50000,
};

export const Achievement_Brick_32506_100: AchievementInfo = {
  id: "achievement_brick_32506_100",
  title: "Bionicle Claw Novice",
  description: "Collect 100 Bionicle Claw",
  category: "brick",
  targetType: "specific",
  targetId: "32506",
  threshold: 100,
};

export const Achievement_Brick_32506_1000: AchievementInfo = {
  id: "achievement_brick_32506_1000",
  title: "Bionicle Claw Collector",
  description: "Collect 1,000 Bionicle Claw",
  category: "brick",
  targetType: "specific",
  targetId: "32506",
  threshold: 1000,
};

export const Achievement_Brick_32506_10000: AchievementInfo = {
  id: "achievement_brick_32506_10000",
  title: "Bionicle Claw Expert",
  description: "Collect 10,000 Bionicle Claw",
  category: "brick",
  targetType: "specific",
  targetId: "32506",
  threshold: 10000,
};

export const Achievement_Brick_32506_50000: AchievementInfo = {
  id: "achievement_brick_32506_50000",
  title: "Bionicle Claw Master",
  description: "Collect 50,000 Bionicle Claw",
  category: "brick",
  targetType: "specific",
  targetId: "32506",
  threshold: 50000,
};

export const Achievement_Brick_42760_100: AchievementInfo = {
  id: "achievement_brick_42760_100",
  title: "Bionicle Ball Joint Novice",
  description: "Collect 100 Bionicle Ball Joint",
  category: "brick",
  targetType: "specific",
  targetId: "42760",
  threshold: 100,
};

export const Achievement_Brick_42760_1000: AchievementInfo = {
  id: "achievement_brick_42760_1000",
  title: "Bionicle Ball Joint Collector",
  description: "Collect 1,000 Bionicle Ball Joint",
  category: "brick",
  targetType: "specific",
  targetId: "42760",
  threshold: 1000,
};

export const Achievement_Brick_42760_10000: AchievementInfo = {
  id: "achievement_brick_42760_10000",
  title: "Bionicle Ball Joint Expert",
  description: "Collect 10,000 Bionicle Ball Joint",
  category: "brick",
  targetType: "specific",
  targetId: "42760",
  threshold: 10000,
};

export const Achievement_Brick_42760_50000: AchievementInfo = {
  id: "achievement_brick_42760_50000",
  title: "Bionicle Ball Joint Master",
  description: "Collect 50,000 Bionicle Ball Joint",
  category: "brick",
  targetType: "specific",
  targetId: "42760",
  threshold: 50000,
};

export const Achievement_Brick_42074_100: AchievementInfo = {
  id: "achievement_brick_42074_100",
  title: "Bionicle Axle Tooth Novice",
  description: "Collect 100 Bionicle Axle Tooth",
  category: "brick",
  targetType: "specific",
  targetId: "42074",
  threshold: 100,
};

export const Achievement_Brick_42074_1000: AchievementInfo = {
  id: "achievement_brick_42074_1000",
  title: "Bionicle Axle Tooth Collector",
  description: "Collect 1,000 Bionicle Axle Tooth",
  category: "brick",
  targetType: "specific",
  targetId: "42074",
  threshold: 1000,
};

export const Achievement_Brick_42074_10000: AchievementInfo = {
  id: "achievement_brick_42074_10000",
  title: "Bionicle Axle Tooth Expert",
  description: "Collect 10,000 Bionicle Axle Tooth",
  category: "brick",
  targetType: "specific",
  targetId: "42074",
  threshold: 10000,
};

export const Achievement_Brick_42074_50000: AchievementInfo = {
  id: "achievement_brick_42074_50000",
  title: "Bionicle Axle Tooth Master",
  description: "Collect 50,000 Bionicle Axle Tooth",
  category: "brick",
  targetType: "specific",
  targetId: "42074",
  threshold: 50000,
};

export const Achievement_Brick_x346_100: AchievementInfo = {
  id: "achievement_brick_x346_100",
  title: "Bionicle Tooth Novice",
  description: "Collect 100 Bionicle Tooth",
  category: "brick",
  targetType: "specific",
  targetId: "x346",
  threshold: 100,
};

export const Achievement_Brick_x346_1000: AchievementInfo = {
  id: "achievement_brick_x346_1000",
  title: "Bionicle Tooth Collector",
  description: "Collect 1,000 Bionicle Tooth",
  category: "brick",
  targetType: "specific",
  targetId: "x346",
  threshold: 1000,
};

export const Achievement_Brick_x346_10000: AchievementInfo = {
  id: "achievement_brick_x346_10000",
  title: "Bionicle Tooth Expert",
  description: "Collect 10,000 Bionicle Tooth",
  category: "brick",
  targetType: "specific",
  targetId: "x346",
  threshold: 10000,
};

export const Achievement_Brick_x346_50000: AchievementInfo = {
  id: "achievement_brick_x346_50000",
  title: "Bionicle Tooth Master",
  description: "Collect 50,000 Bionicle Tooth",
  category: "brick",
  targetType: "specific",
  targetId: "x346",
  threshold: 50000,
};

export const Achievement_Brick_30173_100: AchievementInfo = {
  id: "achievement_brick_30173_100",
  title: "Katana Novice",
  description: "Collect 100 Katana",
  category: "brick",
  targetType: "specific",
  targetId: "30173",
  threshold: 100,
};

export const Achievement_Brick_30173_1000: AchievementInfo = {
  id: "achievement_brick_30173_1000",
  title: "Katana Collector",
  description: "Collect 1,000 Katana",
  category: "brick",
  targetType: "specific",
  targetId: "30173",
  threshold: 1000,
};

export const Achievement_Brick_30173_10000: AchievementInfo = {
  id: "achievement_brick_30173_10000",
  title: "Katana Expert",
  description: "Collect 10,000 Katana",
  category: "brick",
  targetType: "specific",
  targetId: "30173",
  threshold: 10000,
};

export const Achievement_Brick_30173_50000: AchievementInfo = {
  id: "achievement_brick_30173_50000",
  title: "Katana Master",
  description: "Collect 50,000 Katana",
  category: "brick",
  targetType: "specific",
  targetId: "30173",
  threshold: 50000,
};

export const Achievement_Brick_76764_100: AchievementInfo = {
  id: "achievement_brick_76764_100",
  title: "Shortsword Novice",
  description: "Collect 100 Shortsword",
  category: "brick",
  targetType: "specific",
  targetId: "76764",
  threshold: 100,
};

export const Achievement_Brick_76764_1000: AchievementInfo = {
  id: "achievement_brick_76764_1000",
  title: "Shortsword Collector",
  description: "Collect 1,000 Shortsword",
  category: "brick",
  targetType: "specific",
  targetId: "76764",
  threshold: 1000,
};

export const Achievement_Brick_76764_10000: AchievementInfo = {
  id: "achievement_brick_76764_10000",
  title: "Shortsword Expert",
  description: "Collect 10,000 Shortsword",
  category: "brick",
  targetType: "specific",
  targetId: "76764",
  threshold: 10000,
};

export const Achievement_Brick_76764_50000: AchievementInfo = {
  id: "achievement_brick_76764_50000",
  title: "Shortsword Master",
  description: "Collect 50,000 Shortsword",
  category: "brick",
  targetType: "specific",
  targetId: "76764",
  threshold: 50000,
};

export const Achievement_Brick_64644_100: AchievementInfo = {
  id: "achievement_brick_64644_100",
  title: "Telescope Novice",
  description: "Collect 100 Telescope",
  category: "brick",
  targetType: "specific",
  targetId: "64644",
  threshold: 100,
};

export const Achievement_Brick_64644_1000: AchievementInfo = {
  id: "achievement_brick_64644_1000",
  title: "Telescope Collector",
  description: "Collect 1,000 Telescope",
  category: "brick",
  targetType: "specific",
  targetId: "64644",
  threshold: 1000,
};

export const Achievement_Brick_64644_10000: AchievementInfo = {
  id: "achievement_brick_64644_10000",
  title: "Telescope Expert",
  description: "Collect 10,000 Telescope",
  category: "brick",
  targetType: "specific",
  targetId: "64644",
  threshold: 10000,
};

export const Achievement_Brick_64644_50000: AchievementInfo = {
  id: "achievement_brick_64644_50000",
  title: "Telescope Master",
  description: "Collect 50,000 Telescope",
  category: "brick",
  targetType: "specific",
  targetId: "64644",
  threshold: 50000,
};

export const Achievement_Brick_6246f_100: AchievementInfo = {
  id: "achievement_brick_6246f_100",
  title: "Oil Can Novice",
  description: "Collect 100 Oil Can",
  category: "brick",
  targetType: "specific",
  targetId: "6246f",
  threshold: 100,
};

export const Achievement_Brick_6246f_1000: AchievementInfo = {
  id: "achievement_brick_6246f_1000",
  title: "Oil Can Collector",
  description: "Collect 1,000 Oil Can",
  category: "brick",
  targetType: "specific",
  targetId: "6246f",
  threshold: 1000,
};

export const Achievement_Brick_6246f_10000: AchievementInfo = {
  id: "achievement_brick_6246f_10000",
  title: "Oil Can Expert",
  description: "Collect 10,000 Oil Can",
  category: "brick",
  targetType: "specific",
  targetId: "6246f",
  threshold: 10000,
};

export const Achievement_Brick_6246f_50000: AchievementInfo = {
  id: "achievement_brick_6246f_50000",
  title: "Oil Can Master",
  description: "Collect 50,000 Oil Can",
  category: "brick",
  targetType: "specific",
  targetId: "6246f",
  threshold: 50000,
};

export const Achievement_Brick_55297_100: AchievementInfo = {
  id: "achievement_brick_55297_100",
  title: "Drill Novice",
  description: "Collect 100 Drill",
  category: "brick",
  targetType: "specific",
  targetId: "55297",
  threshold: 100,
};

export const Achievement_Brick_55297_1000: AchievementInfo = {
  id: "achievement_brick_55297_1000",
  title: "Drill Collector",
  description: "Collect 1,000 Drill",
  category: "brick",
  targetType: "specific",
  targetId: "55297",
  threshold: 1000,
};

export const Achievement_Brick_55297_10000: AchievementInfo = {
  id: "achievement_brick_55297_10000",
  title: "Drill Expert",
  description: "Collect 10,000 Drill",
  category: "brick",
  targetType: "specific",
  targetId: "55297",
  threshold: 10000,
};

export const Achievement_Brick_55297_50000: AchievementInfo = {
  id: "achievement_brick_55297_50000",
  title: "Drill Master",
  description: "Collect 50,000 Drill",
  category: "brick",
  targetType: "specific",
  targetId: "55297",
  threshold: 50000,
};

export const Achievement_Brick_36752a_100: AchievementInfo = {
  id: "achievement_brick_36752a_100",
  title: "Wand Novice",
  description: "Collect 100 Wand",
  category: "brick",
  targetType: "specific",
  targetId: "36752a",
  threshold: 100,
};

export const Achievement_Brick_36752a_1000: AchievementInfo = {
  id: "achievement_brick_36752a_1000",
  title: "Wand Collector",
  description: "Collect 1,000 Wand",
  category: "brick",
  targetType: "specific",
  targetId: "36752a",
  threshold: 1000,
};

export const Achievement_Brick_36752a_10000: AchievementInfo = {
  id: "achievement_brick_36752a_10000",
  title: "Wand Expert",
  description: "Collect 10,000 Wand",
  category: "brick",
  targetType: "specific",
  targetId: "36752a",
  threshold: 10000,
};

export const Achievement_Brick_36752a_50000: AchievementInfo = {
  id: "achievement_brick_36752a_50000",
  title: "Wand Master",
  description: "Collect 50,000 Wand",
  category: "brick",
  targetType: "specific",
  targetId: "36752a",
  threshold: 50000,
};

export const Achievement_Brick_30229_100: AchievementInfo = {
  id: "achievement_brick_30229_100",
  title: "Pulley Wheel Novice",
  description: "Collect 100 Pulley Wheel",
  category: "brick",
  targetType: "specific",
  targetId: "30229",
  threshold: 100,
};

export const Achievement_Brick_30229_1000: AchievementInfo = {
  id: "achievement_brick_30229_1000",
  title: "Pulley Wheel Collector",
  description: "Collect 1,000 Pulley Wheel",
  category: "brick",
  targetType: "specific",
  targetId: "30229",
  threshold: 1000,
};

export const Achievement_Brick_30229_10000: AchievementInfo = {
  id: "achievement_brick_30229_10000",
  title: "Pulley Wheel Expert",
  description: "Collect 10,000 Pulley Wheel",
  category: "brick",
  targetType: "specific",
  targetId: "30229",
  threshold: 10000,
};

export const Achievement_Brick_30229_50000: AchievementInfo = {
  id: "achievement_brick_30229_50000",
  title: "Pulley Wheel Master",
  description: "Collect 50,000 Pulley Wheel",
  category: "brick",
  targetType: "specific",
  targetId: "30229",
  threshold: 50000,
};

export const Achievement_Brick_30194_100: AchievementInfo = {
  id: "achievement_brick_30194_100",
  title: "Circular Saw Novice",
  description: "Collect 100 Circular Saw",
  category: "brick",
  targetType: "specific",
  targetId: "30194",
  threshold: 100,
};

export const Achievement_Brick_30194_1000: AchievementInfo = {
  id: "achievement_brick_30194_1000",
  title: "Circular Saw Collector",
  description: "Collect 1,000 Circular Saw",
  category: "brick",
  targetType: "specific",
  targetId: "30194",
  threshold: 1000,
};

export const Achievement_Brick_30194_10000: AchievementInfo = {
  id: "achievement_brick_30194_10000",
  title: "Circular Saw Expert",
  description: "Collect 10,000 Circular Saw",
  category: "brick",
  targetType: "specific",
  targetId: "30194",
  threshold: 10000,
};

export const Achievement_Brick_30194_50000: AchievementInfo = {
  id: "achievement_brick_30194_50000",
  title: "Circular Saw Master",
  description: "Collect 50,000 Circular Saw",
  category: "brick",
  targetType: "specific",
  targetId: "30194",
  threshold: 50000,
};

export const Achievement_Brick_64567_100: AchievementInfo = {
  id: "achievement_brick_64567_100",
  title: "Saber Hilt Novice",
  description: "Collect 100 Saber Hilt",
  category: "brick",
  targetType: "specific",
  targetId: "64567",
  threshold: 100,
};

export const Achievement_Brick_64567_1000: AchievementInfo = {
  id: "achievement_brick_64567_1000",
  title: "Saber Hilt Collector",
  description: "Collect 1,000 Saber Hilt",
  category: "brick",
  targetType: "specific",
  targetId: "64567",
  threshold: 1000,
};

export const Achievement_Brick_64567_10000: AchievementInfo = {
  id: "achievement_brick_64567_10000",
  title: "Saber Hilt Expert",
  description: "Collect 10,000 Saber Hilt",
  category: "brick",
  targetType: "specific",
  targetId: "64567",
  threshold: 10000,
};

export const Achievement_Brick_64567_50000: AchievementInfo = {
  id: "achievement_brick_64567_50000",
  title: "Saber Hilt Master",
  description: "Collect 50,000 Saber Hilt",
  category: "brick",
  targetType: "specific",
  targetId: "64567",
  threshold: 50000,
};

export const Achievement_Brick_30035_100: AchievementInfo = {
  id: "achievement_brick_30035_100",
  title: "Space Scanner Novice",
  description: "Collect 100 Space Scanner",
  category: "brick",
  targetType: "specific",
  targetId: "30035",
  threshold: 100,
};

export const Achievement_Brick_30035_1000: AchievementInfo = {
  id: "achievement_brick_30035_1000",
  title: "Space Scanner Collector",
  description: "Collect 1,000 Space Scanner",
  category: "brick",
  targetType: "specific",
  targetId: "30035",
  threshold: 1000,
};

export const Achievement_Brick_30035_10000: AchievementInfo = {
  id: "achievement_brick_30035_10000",
  title: "Space Scanner Expert",
  description: "Collect 10,000 Space Scanner",
  category: "brick",
  targetType: "specific",
  targetId: "30035",
  threshold: 10000,
};

export const Achievement_Brick_30035_50000: AchievementInfo = {
  id: "achievement_brick_30035_50000",
  title: "Space Scanner Master",
  description: "Collect 50,000 Space Scanner",
  category: "brick",
  targetType: "specific",
  targetId: "30035",
  threshold: 50000,
};

export const Achievement_Brick_4493c01pb02_100: AchievementInfo = {
  id: "achievement_brick_4493c01pb02_100",
  title: "Horse Novice",
  description: "Collect 100 Horse",
  category: "brick",
  targetType: "specific",
  targetId: "4493c01pb02",
  threshold: 100,
};

export const Achievement_Brick_4493c01pb02_1000: AchievementInfo = {
  id: "achievement_brick_4493c01pb02_1000",
  title: "Horse Collector",
  description: "Collect 1,000 Horse",
  category: "brick",
  targetType: "specific",
  targetId: "4493c01pb02",
  threshold: 1000,
};

export const Achievement_Brick_4493c01pb02_10000: AchievementInfo = {
  id: "achievement_brick_4493c01pb02_10000",
  title: "Horse Expert",
  description: "Collect 10,000 Horse",
  category: "brick",
  targetType: "specific",
  targetId: "4493c01pb02",
  threshold: 10000,
};

export const Achievement_Brick_4493c01pb02_50000: AchievementInfo = {
  id: "achievement_brick_4493c01pb02_50000",
  title: "Horse Master",
  description: "Collect 50,000 Horse",
  category: "brick",
  targetType: "specific",
  targetId: "4493c01pb02",
  threshold: 50000,
};

export const Achievement_Brick_6086_100: AchievementInfo = {
  id: "achievement_brick_6086_100",
  title: "Octopus Novice",
  description: "Collect 100 Octopus",
  category: "brick",
  targetType: "specific",
  targetId: "6086",
  threshold: 100,
};

export const Achievement_Brick_6086_1000: AchievementInfo = {
  id: "achievement_brick_6086_1000",
  title: "Octopus Collector",
  description: "Collect 1,000 Octopus",
  category: "brick",
  targetType: "specific",
  targetId: "6086",
  threshold: 1000,
};

export const Achievement_Brick_6086_10000: AchievementInfo = {
  id: "achievement_brick_6086_10000",
  title: "Octopus Expert",
  description: "Collect 10,000 Octopus",
  category: "brick",
  targetType: "specific",
  targetId: "6086",
  threshold: 10000,
};

export const Achievement_Brick_6086_50000: AchievementInfo = {
  id: "achievement_brick_6086_50000",
  title: "Octopus Master",
  description: "Collect 50,000 Octopus",
  category: "brick",
  targetType: "specific",
  targetId: "6086",
  threshold: 50000,
};

export const Achievement_Brick_48812_100: AchievementInfo = {
  id: "achievement_brick_48812_100",
  title: "Dog Novice",
  description: "Collect 100 Dog",
  category: "brick",
  targetType: "specific",
  targetId: "48812",
  threshold: 100,
};

export const Achievement_Brick_48812_1000: AchievementInfo = {
  id: "achievement_brick_48812_1000",
  title: "Dog Collector",
  description: "Collect 1,000 Dog",
  category: "brick",
  targetType: "specific",
  targetId: "48812",
  threshold: 1000,
};

export const Achievement_Brick_48812_10000: AchievementInfo = {
  id: "achievement_brick_48812_10000",
  title: "Dog Expert",
  description: "Collect 10,000 Dog",
  category: "brick",
  targetType: "specific",
  targetId: "48812",
  threshold: 10000,
};

export const Achievement_Brick_48812_50000: AchievementInfo = {
  id: "achievement_brick_48812_50000",
  title: "Dog Master",
  description: "Collect 50,000 Dog",
  category: "brick",
  targetType: "specific",
  targetId: "48812",
  threshold: 50000,
};

export const Achievement_Brick_30464_100: AchievementInfo = {
  id: "achievement_brick_30464_100",
  title: "Dinosaur Baby Novice",
  description: "Collect 100 Dinosaur Baby",
  category: "brick",
  targetType: "specific",
  targetId: "30464",
  threshold: 100,
};

export const Achievement_Brick_30464_1000: AchievementInfo = {
  id: "achievement_brick_30464_1000",
  title: "Dinosaur Baby Collector",
  description: "Collect 1,000 Dinosaur Baby",
  category: "brick",
  targetType: "specific",
  targetId: "30464",
  threshold: 1000,
};

export const Achievement_Brick_30464_10000: AchievementInfo = {
  id: "achievement_brick_30464_10000",
  title: "Dinosaur Baby Expert",
  description: "Collect 10,000 Dinosaur Baby",
  category: "brick",
  targetType: "specific",
  targetId: "30464",
  threshold: 10000,
};

export const Achievement_Brick_30464_50000: AchievementInfo = {
  id: "achievement_brick_30464_50000",
  title: "Dinosaur Baby Master",
  description: "Collect 50,000 Dinosaur Baby",
  category: "brick",
  targetType: "specific",
  targetId: "30464",
  threshold: 50000,
};

export const Achievement_Brick_30103_100: AchievementInfo = {
  id: "achievement_brick_30103_100",
  title: "Bat Novice",
  description: "Collect 100 Bat",
  category: "brick",
  targetType: "specific",
  targetId: "30103",
  threshold: 100,
};

export const Achievement_Brick_30103_1000: AchievementInfo = {
  id: "achievement_brick_30103_1000",
  title: "Bat Collector",
  description: "Collect 1,000 Bat",
  category: "brick",
  targetType: "specific",
  targetId: "30103",
  threshold: 1000,
};

export const Achievement_Brick_30103_10000: AchievementInfo = {
  id: "achievement_brick_30103_10000",
  title: "Bat Expert",
  description: "Collect 10,000 Bat",
  category: "brick",
  targetType: "specific",
  targetId: "30103",
  threshold: 10000,
};

export const Achievement_Brick_30103_50000: AchievementInfo = {
  id: "achievement_brick_30103_50000",
  title: "Bat Master",
  description: "Collect 50,000 Bat",
  category: "brick",
  targetType: "specific",
  targetId: "30103",
  threshold: 50000,
};

export const Achievement_Brick_30115_100: AchievementInfo = {
  id: "achievement_brick_30115_100",
  title: "Snake Novice",
  description: "Collect 100 Snake",
  category: "brick",
  targetType: "specific",
  targetId: "30115",
  threshold: 100,
};

export const Achievement_Brick_30115_1000: AchievementInfo = {
  id: "achievement_brick_30115_1000",
  title: "Snake Collector",
  description: "Collect 1,000 Snake",
  category: "brick",
  targetType: "specific",
  targetId: "30115",
  threshold: 1000,
};

export const Achievement_Brick_30115_10000: AchievementInfo = {
  id: "achievement_brick_30115_10000",
  title: "Snake Expert",
  description: "Collect 10,000 Snake",
  category: "brick",
  targetType: "specific",
  targetId: "30115",
  threshold: 10000,
};

export const Achievement_Brick_30115_50000: AchievementInfo = {
  id: "achievement_brick_30115_50000",
  title: "Snake Master",
  description: "Collect 50,000 Snake",
  category: "brick",
  targetType: "specific",
  targetId: "30115",
  threshold: 50000,
};

export const Achievement_Brick_92084_100: AchievementInfo = {
  id: "achievement_brick_92084_100",
  title: "Owl Novice",
  description: "Collect 100 Owl",
  category: "brick",
  targetType: "specific",
  targetId: "92084",
  threshold: 100,
};

export const Achievement_Brick_92084_1000: AchievementInfo = {
  id: "achievement_brick_92084_1000",
  title: "Owl Collector",
  description: "Collect 1,000 Owl",
  category: "brick",
  targetType: "specific",
  targetId: "92084",
  threshold: 1000,
};

export const Achievement_Brick_92084_10000: AchievementInfo = {
  id: "achievement_brick_92084_10000",
  title: "Owl Expert",
  description: "Collect 10,000 Owl",
  category: "brick",
  targetType: "specific",
  targetId: "92084",
  threshold: 10000,
};

export const Achievement_Brick_92084_50000: AchievementInfo = {
  id: "achievement_brick_92084_50000",
  title: "Owl Master",
  description: "Collect 50,000 Owl",
  category: "brick",
  targetType: "specific",
  targetId: "92084",
  threshold: 50000,
};

export const Achievement_Brick_80674_100: AchievementInfo = {
  id: "achievement_brick_80674_100",
  title: "Butterfly Novice",
  description: "Collect 100 Butterfly",
  category: "brick",
  targetType: "specific",
  targetId: "80674",
  threshold: 100,
};

export const Achievement_Brick_80674_1000: AchievementInfo = {
  id: "achievement_brick_80674_1000",
  title: "Butterfly Collector",
  description: "Collect 1,000 Butterfly",
  category: "brick",
  targetType: "specific",
  targetId: "80674",
  threshold: 1000,
};

export const Achievement_Brick_80674_10000: AchievementInfo = {
  id: "achievement_brick_80674_10000",
  title: "Butterfly Expert",
  description: "Collect 10,000 Butterfly",
  category: "brick",
  targetType: "specific",
  targetId: "80674",
  threshold: 10000,
};

export const Achievement_Brick_80674_50000: AchievementInfo = {
  id: "achievement_brick_80674_50000",
  title: "Butterfly Master",
  description: "Collect 50,000 Butterfly",
  category: "brick",
  targetType: "specific",
  targetId: "80674",
  threshold: 50000,
};

export const Achievement_Brick_33121_100: AchievementInfo = {
  id: "achievement_brick_33121_100",
  title: "Crab Novice",
  description: "Collect 100 Crab",
  category: "brick",
  targetType: "specific",
  targetId: "33121",
  threshold: 100,
};

export const Achievement_Brick_33121_1000: AchievementInfo = {
  id: "achievement_brick_33121_1000",
  title: "Crab Collector",
  description: "Collect 1,000 Crab",
  category: "brick",
  targetType: "specific",
  targetId: "33121",
  threshold: 1000,
};

export const Achievement_Brick_33121_10000: AchievementInfo = {
  id: "achievement_brick_33121_10000",
  title: "Crab Expert",
  description: "Collect 10,000 Crab",
  category: "brick",
  targetType: "specific",
  targetId: "33121",
  threshold: 10000,
};

export const Achievement_Brick_33121_50000: AchievementInfo = {
  id: "achievement_brick_33121_50000",
  title: "Crab Master",
  description: "Collect 50,000 Crab",
  category: "brick",
  targetType: "specific",
  targetId: "33121",
  threshold: 50000,
};

export const Achievement_Brick_30238_100: AchievementInfo = {
  id: "achievement_brick_30238_100",
  title: "Spider Novice",
  description: "Collect 100 Spider",
  category: "brick",
  targetType: "specific",
  targetId: "30238",
  threshold: 100,
};

export const Achievement_Brick_30238_1000: AchievementInfo = {
  id: "achievement_brick_30238_1000",
  title: "Spider Collector",
  description: "Collect 1,000 Spider",
  category: "brick",
  targetType: "specific",
  targetId: "30238",
  threshold: 1000,
};

export const Achievement_Brick_30238_10000: AchievementInfo = {
  id: "achievement_brick_30238_10000",
  title: "Spider Expert",
  description: "Collect 10,000 Spider",
  category: "brick",
  targetType: "specific",
  targetId: "30238",
  threshold: 10000,
};

export const Achievement_Brick_30238_50000: AchievementInfo = {
  id: "achievement_brick_30238_50000",
  title: "Spider Master",
  description: "Collect 50,000 Spider",
  category: "brick",
  targetType: "specific",
  targetId: "30238",
  threshold: 50000,
};

export const Achievement_Brick_32567_100: AchievementInfo = {
  id: "achievement_brick_32567_100",
  title: "Ruru Mask Novice",
  description: "Collect 100 Ruru Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32567",
  threshold: 100,
};

export const Achievement_Brick_32567_1000: AchievementInfo = {
  id: "achievement_brick_32567_1000",
  title: "Ruru Mask Collector",
  description: "Collect 1,000 Ruru Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32567",
  threshold: 1000,
};

export const Achievement_Brick_32567_10000: AchievementInfo = {
  id: "achievement_brick_32567_10000",
  title: "Ruru Mask Expert",
  description: "Collect 10,000 Ruru Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32567",
  threshold: 10000,
};

export const Achievement_Brick_32567_50000: AchievementInfo = {
  id: "achievement_brick_32567_50000",
  title: "Ruru Mask Master",
  description: "Collect 50,000 Ruru Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32567",
  threshold: 50000,
};

export const Achievement_Brick_32574_100: AchievementInfo = {
  id: "achievement_brick_32574_100",
  title: "Rau Mask Novice",
  description: "Collect 100 Rau Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32574",
  threshold: 100,
};

export const Achievement_Brick_32574_1000: AchievementInfo = {
  id: "achievement_brick_32574_1000",
  title: "Rau Mask Collector",
  description: "Collect 1,000 Rau Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32574",
  threshold: 1000,
};

export const Achievement_Brick_32574_10000: AchievementInfo = {
  id: "achievement_brick_32574_10000",
  title: "Rau Mask Expert",
  description: "Collect 10,000 Rau Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32574",
  threshold: 10000,
};

export const Achievement_Brick_32574_50000: AchievementInfo = {
  id: "achievement_brick_32574_50000",
  title: "Rau Mask Master",
  description: "Collect 50,000 Rau Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32574",
  threshold: 50000,
};

export const Achievement_Brick_32570_100: AchievementInfo = {
  id: "achievement_brick_32570_100",
  title: "Matatu Mask Novice",
  description: "Collect 100 Matatu Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32570",
  threshold: 100,
};

export const Achievement_Brick_32570_1000: AchievementInfo = {
  id: "achievement_brick_32570_1000",
  title: "Matatu Mask Collector",
  description: "Collect 1,000 Matatu Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32570",
  threshold: 1000,
};

export const Achievement_Brick_32570_10000: AchievementInfo = {
  id: "achievement_brick_32570_10000",
  title: "Matatu Mask Expert",
  description: "Collect 10,000 Matatu Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32570",
  threshold: 10000,
};

export const Achievement_Brick_32570_50000: AchievementInfo = {
  id: "achievement_brick_32570_50000",
  title: "Matatu Mask Master",
  description: "Collect 50,000 Matatu Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32570",
  threshold: 50000,
};

export const Achievement_Brick_32575_100: AchievementInfo = {
  id: "achievement_brick_32575_100",
  title: "Mahiki Mask Novice",
  description: "Collect 100 Mahiki Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32575",
  threshold: 100,
};

export const Achievement_Brick_32575_1000: AchievementInfo = {
  id: "achievement_brick_32575_1000",
  title: "Mahiki Mask Collector",
  description: "Collect 1,000 Mahiki Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32575",
  threshold: 1000,
};

export const Achievement_Brick_32575_10000: AchievementInfo = {
  id: "achievement_brick_32575_10000",
  title: "Mahiki Mask Expert",
  description: "Collect 10,000 Mahiki Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32575",
  threshold: 10000,
};

export const Achievement_Brick_32575_50000: AchievementInfo = {
  id: "achievement_brick_32575_50000",
  title: "Mahiki Mask Master",
  description: "Collect 50,000 Mahiki Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32575",
  threshold: 50000,
};

export const Achievement_Brick_32566_100: AchievementInfo = {
  id: "achievement_brick_32566_100",
  title: "Pakari Mask Novice",
  description: "Collect 100 Pakari Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32566",
  threshold: 100,
};

export const Achievement_Brick_32566_1000: AchievementInfo = {
  id: "achievement_brick_32566_1000",
  title: "Pakari Mask Collector",
  description: "Collect 1,000 Pakari Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32566",
  threshold: 1000,
};

export const Achievement_Brick_32566_10000: AchievementInfo = {
  id: "achievement_brick_32566_10000",
  title: "Pakari Mask Expert",
  description: "Collect 10,000 Pakari Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32566",
  threshold: 10000,
};

export const Achievement_Brick_32566_50000: AchievementInfo = {
  id: "achievement_brick_32566_50000",
  title: "Pakari Mask Master",
  description: "Collect 50,000 Pakari Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32566",
  threshold: 50000,
};

export const Achievement_Brick_32565_100: AchievementInfo = {
  id: "achievement_brick_32565_100",
  title: "Miru Mask Novice",
  description: "Collect 100 Miru Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32565",
  threshold: 100,
};

export const Achievement_Brick_32565_1000: AchievementInfo = {
  id: "achievement_brick_32565_1000",
  title: "Miru Mask Collector",
  description: "Collect 1,000 Miru Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32565",
  threshold: 1000,
};

export const Achievement_Brick_32565_10000: AchievementInfo = {
  id: "achievement_brick_32565_10000",
  title: "Miru Mask Expert",
  description: "Collect 10,000 Miru Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32565",
  threshold: 10000,
};

export const Achievement_Brick_32565_50000: AchievementInfo = {
  id: "achievement_brick_32565_50000",
  title: "Miru Mask Master",
  description: "Collect 50,000 Miru Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32565",
  threshold: 50000,
};

export const Achievement_Brick_32571_100: AchievementInfo = {
  id: "achievement_brick_32571_100",
  title: "KauKau Mask Novice",
  description: "Collect 100 KauKau Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32571",
  threshold: 100,
};

export const Achievement_Brick_32571_1000: AchievementInfo = {
  id: "achievement_brick_32571_1000",
  title: "KauKau Mask Collector",
  description: "Collect 1,000 KauKau Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32571",
  threshold: 1000,
};

export const Achievement_Brick_32571_10000: AchievementInfo = {
  id: "achievement_brick_32571_10000",
  title: "KauKau Mask Expert",
  description: "Collect 10,000 KauKau Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32571",
  threshold: 10000,
};

export const Achievement_Brick_32571_50000: AchievementInfo = {
  id: "achievement_brick_32571_50000",
  title: "KauKau Mask Master",
  description: "Collect 50,000 KauKau Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32571",
  threshold: 50000,
};

export const Achievement_Brick_32568_100: AchievementInfo = {
  id: "achievement_brick_32568_100",
  title: "Kakama Mask Novice",
  description: "Collect 100 Kakama Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32568",
  threshold: 100,
};

export const Achievement_Brick_32568_1000: AchievementInfo = {
  id: "achievement_brick_32568_1000",
  title: "Kakama Mask Collector",
  description: "Collect 1,000 Kakama Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32568",
  threshold: 1000,
};

export const Achievement_Brick_32568_10000: AchievementInfo = {
  id: "achievement_brick_32568_10000",
  title: "Kakama Mask Expert",
  description: "Collect 10,000 Kakama Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32568",
  threshold: 10000,
};

export const Achievement_Brick_32568_50000: AchievementInfo = {
  id: "achievement_brick_32568_50000",
  title: "Kakama Mask Master",
  description: "Collect 50,000 Kakama Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32568",
  threshold: 50000,
};

export const Achievement_Brick_32505_100: AchievementInfo = {
  id: "achievement_brick_32505_100",
  title: "Hau Mask Novice",
  description: "Collect 100 Hau Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32505",
  threshold: 100,
};

export const Achievement_Brick_32505_1000: AchievementInfo = {
  id: "achievement_brick_32505_1000",
  title: "Hau Mask Collector",
  description: "Collect 1,000 Hau Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32505",
  threshold: 1000,
};

export const Achievement_Brick_32505_10000: AchievementInfo = {
  id: "achievement_brick_32505_10000",
  title: "Hau Mask Expert",
  description: "Collect 10,000 Hau Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32505",
  threshold: 10000,
};

export const Achievement_Brick_32505_50000: AchievementInfo = {
  id: "achievement_brick_32505_50000",
  title: "Hau Mask Master",
  description: "Collect 50,000 Hau Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32505",
  threshold: 50000,
};

export const Achievement_Brick_32573_100: AchievementInfo = {
  id: "achievement_brick_32573_100",
  title: "Huna Mask Novice",
  description: "Collect 100 Huna Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32573",
  threshold: 100,
};

export const Achievement_Brick_32573_1000: AchievementInfo = {
  id: "achievement_brick_32573_1000",
  title: "Huna Mask Collector",
  description: "Collect 1,000 Huna Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32573",
  threshold: 1000,
};

export const Achievement_Brick_32573_10000: AchievementInfo = {
  id: "achievement_brick_32573_10000",
  title: "Huna Mask Expert",
  description: "Collect 10,000 Huna Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32573",
  threshold: 10000,
};

export const Achievement_Brick_32573_50000: AchievementInfo = {
  id: "achievement_brick_32573_50000",
  title: "Huna Mask Master",
  description: "Collect 50,000 Huna Mask",
  category: "brick",
  targetType: "specific",
  targetId: "32573",
  threshold: 50000,
};

export const Achievement_Brick_4740_100: AchievementInfo = {
  id: "achievement_brick_4740_100",
  title: "Dish 2x2 Radar Novice",
  description: "Collect 100 Dish 2x2 Radar",
  category: "brick",
  targetType: "specific",
  targetId: "4740",
  threshold: 100,
};

export const Achievement_Brick_4740_1000: AchievementInfo = {
  id: "achievement_brick_4740_1000",
  title: "Dish 2x2 Radar Collector",
  description: "Collect 1,000 Dish 2x2 Radar",
  category: "brick",
  targetType: "specific",
  targetId: "4740",
  threshold: 1000,
};

export const Achievement_Brick_4740_10000: AchievementInfo = {
  id: "achievement_brick_4740_10000",
  title: "Dish 2x2 Radar Expert",
  description: "Collect 10,000 Dish 2x2 Radar",
  category: "brick",
  targetType: "specific",
  targetId: "4740",
  threshold: 10000,
};

export const Achievement_Brick_4740_50000: AchievementInfo = {
  id: "achievement_brick_4740_50000",
  title: "Dish 2x2 Radar Master",
  description: "Collect 50,000 Dish 2x2 Radar",
  category: "brick",
  targetType: "specific",
  targetId: "4740",
  threshold: 50000,
};

export const Achievement_Brick_6014b_100: AchievementInfo = {
  id: "achievement_brick_6014b_100",
  title: "Wheel 11mm Novice",
  description: "Collect 100 Wheel 11mm",
  category: "brick",
  targetType: "specific",
  targetId: "6014b",
  threshold: 100,
};

export const Achievement_Brick_6014b_1000: AchievementInfo = {
  id: "achievement_brick_6014b_1000",
  title: "Wheel 11mm Collector",
  description: "Collect 1,000 Wheel 11mm",
  category: "brick",
  targetType: "specific",
  targetId: "6014b",
  threshold: 1000,
};

export const Achievement_Brick_6014b_10000: AchievementInfo = {
  id: "achievement_brick_6014b_10000",
  title: "Wheel 11mm Expert",
  description: "Collect 10,000 Wheel 11mm",
  category: "brick",
  targetType: "specific",
  targetId: "6014b",
  threshold: 10000,
};

export const Achievement_Brick_6014b_50000: AchievementInfo = {
  id: "achievement_brick_6014b_50000",
  title: "Wheel 11mm Master",
  description: "Collect 50,000 Wheel 11mm",
  category: "brick",
  targetType: "specific",
  targetId: "6014b",
  threshold: 50000,
};

export const Achievement_Brick_3960_100: AchievementInfo = {
  id: "achievement_brick_3960_100",
  title: "Dish 4x4 Radar Novice",
  description: "Collect 100 Dish 4x4 Radar",
  category: "brick",
  targetType: "specific",
  targetId: "3960",
  threshold: 100,
};

export const Achievement_Brick_3960_1000: AchievementInfo = {
  id: "achievement_brick_3960_1000",
  title: "Dish 4x4 Radar Collector",
  description: "Collect 1,000 Dish 4x4 Radar",
  category: "brick",
  targetType: "specific",
  targetId: "3960",
  threshold: 1000,
};

export const Achievement_Brick_3960_10000: AchievementInfo = {
  id: "achievement_brick_3960_10000",
  title: "Dish 4x4 Radar Expert",
  description: "Collect 10,000 Dish 4x4 Radar",
  category: "brick",
  targetType: "specific",
  targetId: "3960",
  threshold: 10000,
};

export const Achievement_Brick_3960_50000: AchievementInfo = {
  id: "achievement_brick_3960_50000",
  title: "Dish 4x4 Radar Master",
  description: "Collect 50,000 Dish 4x4 Radar",
  category: "brick",
  targetType: "specific",
  targetId: "3960",
  threshold: 50000,
};

export const Achievement_Brick_50990b_100: AchievementInfo = {
  id: "achievement_brick_50990b_100",
  title: "Dish 10x10 Radar Novice",
  description: "Collect 100 Dish 10x10 Radar",
  category: "brick",
  targetType: "specific",
  targetId: "50990b",
  threshold: 100,
};

export const Achievement_Brick_50990b_1000: AchievementInfo = {
  id: "achievement_brick_50990b_1000",
  title: "Dish 10x10 Radar Collector",
  description: "Collect 1,000 Dish 10x10 Radar",
  category: "brick",
  targetType: "specific",
  targetId: "50990b",
  threshold: 1000,
};

export const Achievement_Brick_50990b_10000: AchievementInfo = {
  id: "achievement_brick_50990b_10000",
  title: "Dish 10x10 Radar Expert",
  description: "Collect 10,000 Dish 10x10 Radar",
  category: "brick",
  targetType: "specific",
  targetId: "50990b",
  threshold: 10000,
};

export const Achievement_Brick_50990b_50000: AchievementInfo = {
  id: "achievement_brick_50990b_50000",
  title: "Dish 10x10 Radar Master",
  description: "Collect 50,000 Dish 10x10 Radar",
  category: "brick",
  targetType: "specific",
  targetId: "50990b",
  threshold: 50000,
};

export const Achievement_Brick_2489_100: AchievementInfo = {
  id: "achievement_brick_2489_100",
  title: "Barrel 2x2x2 Radar Novice",
  description: "Collect 100 Barrel 2x2x2 Radar",
  category: "brick",
  targetType: "specific",
  targetId: "2489",
  threshold: 100,
};

export const Achievement_Brick_2489_1000: AchievementInfo = {
  id: "achievement_brick_2489_1000",
  title: "Barrel 2x2x2 Radar Collector",
  description: "Collect 1,000 Barrel 2x2x2 Radar",
  category: "brick",
  targetType: "specific",
  targetId: "2489",
  threshold: 1000,
};

export const Achievement_Brick_2489_10000: AchievementInfo = {
  id: "achievement_brick_2489_10000",
  title: "Barrel 2x2x2 Radar Expert",
  description: "Collect 10,000 Barrel 2x2x2 Radar",
  category: "brick",
  targetType: "specific",
  targetId: "2489",
  threshold: 10000,
};

export const Achievement_Brick_2489_50000: AchievementInfo = {
  id: "achievement_brick_2489_50000",
  title: "Barrel 2x2x2 Radar Master",
  description: "Collect 50,000 Barrel 2x2x2 Radar",
  category: "brick",
  targetType: "specific",
  targetId: "2489",
  threshold: 50000,
};

export const Achievement_Brick_30139_100: AchievementInfo = {
  id: "achievement_brick_30139_100",
  title: "Barrel 4x4x4",
  description: "Collect 100 Barrel 4x4x4",
  category: "brick",
  targetType: "specific",
  targetId: "30139",
  threshold: 100,
};

export const Achievement_Brick_30139_1000: AchievementInfo = {
  id: "achievement_brick_30139_1000",
  title: "Barrel 4x4x4 Collector",
  description: "Collect 1,000 Barrel 4x4x4",
  category: "brick",
  targetType: "specific",
  targetId: "30139",
  threshold: 1000,
};

export const Achievement_Brick_30139_10000: AchievementInfo = {
  id: "achievement_brick_30139_10000",
  title: "Barrel 4x4x4 Radar Expert",
  description: "Collect 10,000 Barrel 4x4x4",
  category: "brick",
  targetType: "specific",
  targetId: "30139",
  threshold: 10000,
};

export const Achievement_Brick_30139_50000: AchievementInfo = {
  id: "achievement_brick_30139_50000",
  title: "Barrel 4x4x4 Master",
  description: "Collect 50,000 Barrel 4x4x4",
  category: "brick",
  targetType: "specific",
  targetId: "30139",
  threshold: 50000,
};

export const Achievement_Brick_6222_100: AchievementInfo = {
  id: "achievement_brick_6222_100",
  title: "Brick Round 4x4 Novice",
  description: "Collect 100 Brick Round 4x4",
  category: "brick",
  targetType: "specific",
  targetId: "6222",
  threshold: 100,
};

export const Achievement_Brick_6222_1000: AchievementInfo = {
  id: "achievement_brick_6222_1000",
  title: "Brick Round 4x4 Collector",
  description: "Collect 1,000 Brick Round 4x4",
  category: "brick",
  targetType: "specific",
  targetId: "6222",
  threshold: 1000,
};

export const Achievement_Brick_6222_10000: AchievementInfo = {
  id: "achievement_brick_6222_10000",
  title: "Brick Round 4x4 Expert",
  description: "Collect 10,000 Brick Round 4x4",
  category: "brick",
  targetType: "specific",
  targetId: "6222",
  threshold: 10000,
};

export const Achievement_Brick_6222_50000: AchievementInfo = {
  id: "achievement_brick_6222_50000",
  title: "Brick Round 4x4 Master",
  description: "Collect 50,000 Brick Round 4x4",
  category: "brick",
  targetType: "specific",
  targetId: "6222",
  threshold: 50000,
};

export const Achievement_Brick_41531_100: AchievementInfo = {
  id: "achievement_brick_41531_100",
  title: "Cylinder 4x4 Novice",
  description: "Collect 100 Cylinder 4x4",
  category: "brick",
  targetType: "specific",
  targetId: "41531",
  threshold: 100,
};

export const Achievement_Brick_41531_1000: AchievementInfo = {
  id: "achievement_brick_41531_1000",
  title: "Cylinder 4x4 Collector",
  description: "Collect 1,000 Cylinder 4x4",
  category: "brick",
  targetType: "specific",
  targetId: "41531",
  threshold: 1000,
};

export const Achievement_Brick_41531_10000: AchievementInfo = {
  id: "achievement_brick_41531_10000",
  title: "Cylinder 4x4 Expert",
  description: "Collect 10,000 Cylinder 4x4",
  category: "brick",
  targetType: "specific",
  targetId: "41531",
  threshold: 10000,
};

export const Achievement_Brick_41531_50000: AchievementInfo = {
  id: "achievement_brick_41531_50000",
  title: "Cylinder 4x4 Master",
  description: "Collect 50,000 Cylinder 4x4",
  category: "brick",
  targetType: "specific",
  targetId: "41531",
  threshold: 50000,
};

export const Achievement_Brick_30360_100: AchievementInfo = {
  id: "achievement_brick_30360_100",
  title: "Cylinder 3x6 Novice",
  description: "Collect 100 Cylinder 3x6",
  category: "brick",
  targetType: "specific",
  targetId: "30360",
  threshold: 100,
};

export const Achievement_Brick_30360_1000: AchievementInfo = {
  id: "achievement_brick_30360_1000",
  title: "Cylinder 3x6 Collector",
  description: "Collect 1,000 Cylinder 3x6",
  category: "brick",
  targetType: "specific",
  targetId: "30360",
  threshold: 1000,
};

export const Achievement_Brick_30360_10000: AchievementInfo = {
  id: "achievement_brick_30360_10000",
  title: "Cylinder 3x6 Expert",
  description: "Collect 10,000 Cylinder 3x6",
  category: "brick",
  targetType: "specific",
  targetId: "30360",
  threshold: 10000,
};

export const Achievement_Brick_30360_50000: AchievementInfo = {
  id: "achievement_brick_30360_50000",
  title: "Cylinder 3x6 Master",
  description: "Collect 50,000 Cylinder 3x6",
  category: "brick",
  targetType: "specific",
  targetId: "30360",
  threshold: 50000,
};

export const Achievement_Brick_4285b_100: AchievementInfo = {
  id: "achievement_brick_4285b_100",
  title: "Dish 6x6 Webbed Novice",
  description: "Collect 100 Dish 6x6 Webbed",
  category: "brick",
  targetType: "specific",
  targetId: "4285b",
  threshold: 100,
};

export const Achievement_Brick_4285b_1000: AchievementInfo = {
  id: "achievement_brick_4285b_1000",
  title: "Dish 6x6 Webbed Collector",
  description: "Collect 1,000 Dish 6x6 Webbed",
  category: "brick",
  targetType: "specific",
  targetId: "4285b",
  threshold: 1000,
};

export const Achievement_Brick_4285b_10000: AchievementInfo = {
  id: "achievement_brick_4285b_10000",
  title: "Dish 6x6 Webbed Expert",
  description: "Collect 10,000 Dish 6x6 Webbed",
  category: "brick",
  targetType: "specific",
  targetId: "4285b",
  threshold: 10000,
};

export const Achievement_Brick_4285b_50000: AchievementInfo = {
  id: "achievement_brick_4285b_50000",
  title: "Dish 6x6 Webbed Master",
  description: "Collect 50,000 Dish 6x6 Webbed",
  category: "brick",
  targetType: "specific",
  targetId: "4285b",
  threshold: 50000,
};

export const Achievement_Brick_3901_100: AchievementInfo = {
  id: "achievement_brick_3901_100",
  title: "Male Smooth Novice",
  description: "Collect 100 Male Smooth",
  category: "brick",
  targetType: "specific",
  targetId: "3901",
  threshold: 100,
};

export const Achievement_Brick_3901_1000: AchievementInfo = {
  id: "achievement_brick_3901_1000",
  title: "Male Smooth Collector",
  description: "Collect 1,000 Male Smooth",
  category: "brick",
  targetType: "specific",
  targetId: "3901",
  threshold: 1000,
};

export const Achievement_Brick_3901_10000: AchievementInfo = {
  id: "achievement_brick_3901_10000",
  title: "Male Smooth Expert",
  description: "Collect 10,000 Male Smooth",
  category: "brick",
  targetType: "specific",
  targetId: "3901",
  threshold: 10000,
};

export const Achievement_Brick_3901_50000: AchievementInfo = {
  id: "achievement_brick_3901_50000",
  title: "Male Smooth Master",
  description: "Collect 50,000 Male Smooth",
  category: "brick",
  targetType: "specific",
  targetId: "3901",
  threshold: 50000,
};

export const Achievement_Brick_62696_100: AchievementInfo = {
  id: "achievement_brick_62696_100",
  title: "Female Ponytail Novice",
  description: "Collect 100 Female Ponytail",
  category: "brick",
  targetType: "specific",
  targetId: "62696",
  threshold: 100,
};

export const Achievement_Brick_62696_1000: AchievementInfo = {
  id: "achievement_brick_62696_1000",
  title: "Female Ponytail Collector",
  description: "Collect 1,000 Female Ponytail",
  category: "brick",
  targetType: "specific",
  targetId: "62696",
  threshold: 1000,
};

export const Achievement_Brick_62696_10000: AchievementInfo = {
  id: "achievement_brick_62696_10000",
  title: "Female Ponytail Expert",
  description: "Collect 10,000 Female Ponytail",
  category: "brick",
  targetType: "specific",
  targetId: "62696",
  threshold: 10000,
};

export const Achievement_Brick_62696_50000: AchievementInfo = {
  id: "achievement_brick_62696_50000",
  title: "Female Ponytail Master",
  description: "Collect 50,000 Female Ponytail",
  category: "brick",
  targetType: "specific",
  targetId: "62696",
  threshold: 50000,
};

export const Achievement_Brick_53982_100: AchievementInfo = {
  id: "achievement_brick_53982_100",
  title: "Angular Swept Back Novice",
  description: "Collect 100 Angular Swept Back",
  category: "brick",
  targetType: "specific",
  targetId: "53982",
  threshold: 100,
};

export const Achievement_Brick_53982_1000: AchievementInfo = {
  id: "achievement_brick_53982_1000",
  title: "Angular Swept Back Collector",
  description: "Collect 1,000 Angular Swept Back",
  category: "brick",
  targetType: "specific",
  targetId: "53982",
  threshold: 1000,
};

export const Achievement_Brick_53982_10000: AchievementInfo = {
  id: "achievement_brick_53982_10000",
  title: "Angular Swept Back Expert",
  description: "Collect 10,000 Angular Swept Back",
  category: "brick",
  targetType: "specific",
  targetId: "53982",
  threshold: 10000,
};

export const Achievement_Brick_53982_50000: AchievementInfo = {
  id: "achievement_brick_53982_50000",
  title: "Angular Swept Back Master",
  description: "Collect 50,000 Angular Swept Back",
  category: "brick",
  targetType: "specific",
  targetId: "53982",
  threshold: 50000,
};

export const Achievement_Brick_53981_100: AchievementInfo = {
  id: "achievement_brick_53981_100",
  title: "Angular Swept Sideways Novice",
  description: "Collect 100 Angular Swept Sideways",
  category: "brick",
  targetType: "specific",
  targetId: "53981",
  threshold: 100,
};

export const Achievement_Brick_53981_1000: AchievementInfo = {
  id: "achievement_brick_53981_1000",
  title: "Angular Swept Sideways Collector",
  description: "Collect 1,000 Angular Swept Sideways",
  category: "brick",
  targetType: "specific",
  targetId: "53981",
  threshold: 1000,
};

export const Achievement_Brick_53981_10000: AchievementInfo = {
  id: "achievement_brick_53981_10000",
  title: "Angular Swept Sideways Expert",
  description: "Collect 10,000 Angular Swept Sideways",
  category: "brick",
  targetType: "specific",
  targetId: "53981",
  threshold: 10000,
};

export const Achievement_Brick_53981_50000: AchievementInfo = {
  id: "achievement_brick_53981_50000",
  title: "Angular Swept Sideways Master",
  description: "Collect 50,000 Angular Swept Sideways",
  category: "brick",
  targetType: "specific",
  targetId: "53981",
  threshold: 50000,
};

export const Achievement_Brick_26139_100: AchievementInfo = {
  id: "achievement_brick_26139_100",
  title: "Short Wavy Novice",
  description: "Collect 100 Short Wavy",
  category: "brick",
  targetType: "specific",
  targetId: "26139",
  threshold: 100,
};

export const Achievement_Brick_26139_1000: AchievementInfo = {
  id: "achievement_brick_26139_1000",
  title: "Short Wavy Collector",
  description: "Collect 1,000 Short Wavy",
  category: "brick",
  targetType: "specific",
  targetId: "26139",
  threshold: 1000,
};

export const Achievement_Brick_26139_10000: AchievementInfo = {
  id: "achievement_brick_26139_10000",
  title: "Short Wavy Expert",
  description: "Collect 10,000 Short Wavy",
  category: "brick",
  targetType: "specific",
  targetId: "26139",
  threshold: 10000,
};

export const Achievement_Brick_26139_50000: AchievementInfo = {
  id: "achievement_brick_26139_50000",
  title: "Short Wavy Master",
  description: "Collect 50,000 Short Wavy",
  category: "brick",
  targetType: "specific",
  targetId: "26139",
  threshold: 50000,
};

export const Achievement_Brick_42444_100: AchievementInfo = {
  id: "achievement_brick_42444_100",
  title: "Pointed Hair Novice",
  description: "Collect 100 Pointed Hair",
  category: "brick",
  targetType: "specific",
  targetId: "42444",
  threshold: 100,
};

export const Achievement_Brick_42444_1000: AchievementInfo = {
  id: "achievement_brick_42444_1000",
  title: "Pointed Hair Collector",
  description: "Collect 1,000 Pointed Hair",
  category: "brick",
  targetType: "specific",
  targetId: "42444",
  threshold: 1000,
};

export const Achievement_Brick_42444_10000: AchievementInfo = {
  id: "achievement_brick_42444_10000",
  title: "Pointed Hair Expert",
  description: "Collect 10,000 Pointed Hair",
  category: "brick",
  targetType: "specific",
  targetId: "42444",
  threshold: 10000,
};

export const Achievement_Brick_42444_50000: AchievementInfo = {
  id: "achievement_brick_42444_50000",
  title: "Pointed Hair Master",
  description: "Collect 50,000 Pointed Hair",
  category: "brick",
  targetType: "specific",
  targetId: "42444",
  threshold: 50000,
};

export const Achievement_Brick_30410_100: AchievementInfo = {
  id: "achievement_brick_30410_100",
  title: "Hair Pulled Back Novice",
  description: "Collect 100 Hair Pulled Back",
  category: "brick",
  targetType: "specific",
  targetId: "30410",
  threshold: 100,
};

export const Achievement_Brick_30410_1000: AchievementInfo = {
  id: "achievement_brick_30410_1000",
  title: "Hair Pulled Back Collector",
  description: "Collect 1,000 Hair Pulled Back",
  category: "brick",
  targetType: "specific",
  targetId: "30410",
  threshold: 1000,
};

export const Achievement_Brick_30410_10000: AchievementInfo = {
  id: "achievement_brick_30410_10000",
  title: "Hair Pulled Back Expert",
  description: "Collect 10,000 Hair Pulled Back",
  category: "brick",
  targetType: "specific",
  targetId: "30410",
  threshold: 10000,
};

export const Achievement_Brick_30410_50000: AchievementInfo = {
  id: "achievement_brick_30410_50000",
  title: "Hair Pulled Back Master",
  description: "Collect 50,000 Hair Pulled Back",
  category: "brick",
  targetType: "specific",
  targetId: "30410",
  threshold: 50000,
};

export const Achievement_Brick_87991_100: AchievementInfo = {
  id: "achievement_brick_87991_100",
  title: "Hair Tousled Novice",
  description: "Collect 100 Hair Tousled",
  category: "brick",
  targetType: "specific",
  targetId: "87991",
  threshold: 100,
};

export const Achievement_Brick_87991_1000: AchievementInfo = {
  id: "achievement_brick_87991_1000",
  title: "Hair Tousled Collector",
  description: "Collect 1,000 Hair Tousled",
  category: "brick",
  targetType: "specific",
  targetId: "87991",
  threshold: 1000,
};

export const Achievement_Brick_87991_10000: AchievementInfo = {
  id: "achievement_brick_87991_10000",
  title: "Hair Tousled Expert",
  description: "Collect 10,000 Hair Tousled",
  category: "brick",
  targetType: "specific",
  targetId: "87991",
  threshold: 10000,
};

export const Achievement_Brick_87991_50000: AchievementInfo = {
  id: "achievement_brick_87991_50000",
  title: "Hair Tousled Master",
  description: "Collect 50,000 Hair Tousled",
  category: "brick",
  targetType: "specific",
  targetId: "87991",
  threshold: 50000,
};

export const Achievement_Brick_13768_100: AchievementInfo = {
  id: "achievement_brick_13768_100",
  title: "Long Hair and Beard Novice",
  description: "Collect 100 Long Hair and Beard",
  category: "brick",
  targetType: "specific",
  targetId: "13768",
  threshold: 100,
};

export const Achievement_Brick_13768_1000: AchievementInfo = {
  id: "achievement_brick_13768_1000",
  title: "Long Hair and Beard Collector",
  description: "Collect 1,000 Long Hair and Beard",
  category: "brick",
  targetType: "specific",
  targetId: "13768",
  threshold: 1000,
};

export const Achievement_Brick_13768_10000: AchievementInfo = {
  id: "achievement_brick_13768_10000",
  title: "Long Hair and Beard Expert",
  description: "Collect 10,000 Long Hair and Beard",
  category: "brick",
  targetType: "specific",
  targetId: "13768",
  threshold: 10000,
};

export const Achievement_Brick_13768_50000: AchievementInfo = {
  id: "achievement_brick_13768_50000",
  title: "Long Hair and Beard Master",
  description: "Collect 50,000 Long Hair and Beard",
  category: "brick",
  targetType: "specific",
  targetId: "13768",
  threshold: 50000,
};

export const Achievement_Brick_37784_100: AchievementInfo = {
  id: "achievement_brick_37784_100",
  title: "Shaggy Hair with Beard Novice",
  description: "Collect 100 Shaggy Hair with Beard",
  category: "brick",
  targetType: "specific",
  targetId: "37784",
  threshold: 100,
};

export const Achievement_Brick_37784_1000: AchievementInfo = {
  id: "achievement_brick_37784_1000",
  title: "Shaggy Hair with Beard Collector",
  description: "Collect 1,000 Shaggy Hair with Beard",
  category: "brick",
  targetType: "specific",
  targetId: "37784",
  threshold: 1000,
};

export const Achievement_Brick_37784_10000: AchievementInfo = {
  id: "achievement_brick_37784_10000",
  title: "Shaggy Hair with Beard Expert",
  description: "Collect 10,000 Shaggy Hair with Beard",
  category: "brick",
  targetType: "specific",
  targetId: "37784",
  threshold: 10000,
};

export const Achievement_Brick_37784_50000: AchievementInfo = {
  id: "achievement_brick_37784_50000",
  title: "Shaggy Hair with Beard Master",
  description: "Collect 50,000 Shaggy Hair with Beard",
  category: "brick",
  targetType: "specific",
  targetId: "37784",
  threshold: 50000,
};

export const Achievement_Brick_3713_100: AchievementInfo = {
  id: "achievement_brick_3713_100",
  title: "Technic Bush Novice",
  description: "Collect 100 Technic Bush",
  category: "brick",
  targetType: "specific",
  targetId: "3713",
  threshold: 100,
};

export const Achievement_Brick_3713_1000: AchievementInfo = {
  id: "achievement_brick_3713_1000",
  title: "Technic Bush Collector",
  description: "Collect 1,000 Technic Bush",
  category: "brick",
  targetType: "specific",
  targetId: "3713",
  threshold: 1000,
};

export const Achievement_Brick_3713_10000: AchievementInfo = {
  id: "achievement_brick_3713_10000",
  title: "Technic Bush Expert",
  description: "Collect 10,000 Technic Bush",
  category: "brick",
  targetType: "specific",
  targetId: "3713",
  threshold: 10000,
};

export const Achievement_Brick_3713_50000: AchievementInfo = {
  id: "achievement_brick_3713_50000",
  title: "Technic Bush Master",
  description: "Collect 50,000 Technic Bush",
  category: "brick",
  targetType: "specific",
  targetId: "3713",
  threshold: 50000,
};

export const Achievement_Brick_3749_100: AchievementInfo = {
  id: "achievement_brick_3749_100",
  title: "Axle 1l with Pin Novice",
  description: "Collect 100 Axle 1l with Pin",
  category: "brick",
  targetType: "specific",
  targetId: "3749",
  threshold: 100,
};

export const Achievement_Brick_3749_1000: AchievementInfo = {
  id: "achievement_brick_3749_1000",
  title: "Axle 1l with Pin Collector",
  description: "Collect 1,000 Axle 1l with Pin",
  category: "brick",
  targetType: "specific",
  targetId: "3749",
  threshold: 1000,
};

export const Achievement_Brick_3749_10000: AchievementInfo = {
  id: "achievement_brick_3749_10000",
  title: "Axle 1l with Pin Expert",
  description: "Collect 10,000 Axle 1l with Pin",
  category: "brick",
  targetType: "specific",
  targetId: "3749",
  threshold: 10000,
};

export const Achievement_Brick_3749_50000: AchievementInfo = {
  id: "achievement_brick_3749_50000",
  title: "Axle 1l with Pin Master",
  description: "Collect 50,000 Axle 1l with Pin",
  category: "brick",
  targetType: "specific",
  targetId: "3749",
  threshold: 50000,
};

export const Achievement_Brick_24316_100: AchievementInfo = {
  id: "achievement_brick_24316_100",
  title: "Axle 3l with Stop Novice",
  description: "Collect 100 Axle 3l with Stop",
  category: "brick",
  targetType: "specific",
  targetId: "24316",
  threshold: 100,
};

export const Achievement_Brick_24316_1000: AchievementInfo = {
  id: "achievement_brick_24316_1000",
  title: "Axle 3l with Stop Collector",
  description: "Collect 1,000 Axle 3l with Stop",
  category: "brick",
  targetType: "specific",
  targetId: "24316",
  threshold: 1000,
};

export const Achievement_Brick_24316_10000: AchievementInfo = {
  id: "achievement_brick_24316_10000",
  title: "Axle 3l with Stop Expert",
  description: "Collect 10,000 Axle 3l with Stop",
  category: "brick",
  targetType: "specific",
  targetId: "24316",
  threshold: 10000,
};

export const Achievement_Brick_24316_50000: AchievementInfo = {
  id: "achievement_brick_24316_50000",
  title: "Axle 3l with Stop Master",
  description: "Collect 50,000 Axle 3l with Stop",
  category: "brick",
  targetType: "specific",
  targetId: "24316",
  threshold: 50000,
};

export const Achievement_Brick_73230_100: AchievementInfo = {
  id: "achievement_brick_73230_100",
  title: "Brick 1x1 with Axle Hole Novice",
  description: "Collect 100 Brick 1x1 with Axle Hole",
  category: "brick",
  targetType: "specific",
  targetId: "73230",
  threshold: 100,
};

export const Achievement_Brick_73230_1000: AchievementInfo = {
  id: "achievement_brick_73230_1000",
  title: "Brick 1x1 with Axle Hole Collector",
  description: "Collect 1,000 Brick 1x1 with Axle Hole",
  category: "brick",
  targetType: "specific",
  targetId: "73230",
  threshold: 1000,
};

export const Achievement_Brick_73230_10000: AchievementInfo = {
  id: "achievement_brick_73230_10000",
  title: "Brick 1x1 with Axle Hole Expert",
  description: "Collect 10,000 Brick 1x1 with Axle Hole",
  category: "brick",
  targetType: "specific",
  targetId: "73230",
  threshold: 10000,
};

export const Achievement_Brick_73230_50000: AchievementInfo = {
  id: "achievement_brick_73230_50000",
  title: "Brick 1x1 with Axle Hole Master",
  description: "Collect 50,000 Brick 1x1 with Axle Hole",
  category: "brick",
  targetType: "specific",
  targetId: "73230",
  threshold: 50000,
};

export const Achievement_Brick_3701_100: AchievementInfo = {
  id: "achievement_brick_3701_100",
  title: "Brick 1x4 with Holes Novice",
  description: "Collect 100 Brick 1x4 with Holes",
  category: "brick",
  targetType: "specific",
  targetId: "3701",
  threshold: 100,
};

export const Achievement_Brick_3701_1000: AchievementInfo = {
  id: "achievement_brick_3701_1000",
  title: "Brick 1x4 with Holes Collector",
  description: "Collect 1,000 Brick 1x4 with Holes",
  category: "brick",
  targetType: "specific",
  targetId: "3701",
  threshold: 1000,
};

export const Achievement_Brick_3701_10000: AchievementInfo = {
  id: "achievement_brick_3701_10000",
  title: "Brick 1x4 with Holes Expert",
  description: "Collect 10,000 Brick 1x4 with Holes",
  category: "brick",
  targetType: "specific",
  targetId: "3701",
  threshold: 10000,
};

export const Achievement_Brick_3701_50000: AchievementInfo = {
  id: "achievement_brick_3701_50000",
  title: "Brick 1x4 with Holes Master",
  description: "Collect 50,000 Brick 1x4 with Holes",
  category: "brick",
  targetType: "specific",
  targetId: "3701",
  threshold: 50000,
};

export const Achievement_Brick_32174_100: AchievementInfo = {
  id: "achievement_brick_32174_100",
  title: "Axle Connector Novice",
  description: "Collect 100 Axle Connector",
  category: "brick",
  targetType: "specific",
  targetId: "32174",
  threshold: 100,
};

export const Achievement_Brick_32174_1000: AchievementInfo = {
  id: "achievement_brick_32174_1000",
  title: "Axle Connector Collector",
  description: "Collect 1,000 Axle Connector",
  category: "brick",
  targetType: "specific",
  targetId: "32174",
  threshold: 1000,
};

export const Achievement_Brick_32174_10000: AchievementInfo = {
  id: "achievement_brick_32174_10000",
  title: "Axle Connector Expert",
  description: "Collect 10,000 Axle Connector",
  category: "brick",
  targetType: "specific",
  targetId: "32174",
  threshold: 10000,
};

export const Achievement_Brick_32174_50000: AchievementInfo = {
  id: "achievement_brick_32174_50000",
  title: "Axle Connector Master",
  description: "Collect 50,000 Axle Connector",
  category: "brick",
  targetType: "specific",
  targetId: "32174",
  threshold: 50000,
};

export const Achievement_Brick_32034_100: AchievementInfo = {
  id: "achievement_brick_32034_100",
  title: "Axle Pin Connector Novice",
  description: "Collect 100 Axle Pin Connector",
  category: "brick",
  targetType: "specific",
  targetId: "32034",
  threshold: 100,
};

export const Achievement_Brick_32034_1000: AchievementInfo = {
  id: "achievement_brick_32034_1000",
  title: "Axle Pin Connector Collector",
  description: "Collect 1,000 Axle Pin Connector",
  category: "brick",
  targetType: "specific",
  targetId: "32034",
  threshold: 1000,
};

export const Achievement_Brick_32034_10000: AchievementInfo = {
  id: "achievement_brick_32034_10000",
  title: "Axle Pin Connector Expert",
  description: "Collect 10,000 Axle Pin Connector",
  category: "brick",
  targetType: "specific",
  targetId: "32034",
  threshold: 10000,
};

export const Achievement_Brick_32034_50000: AchievementInfo = {
  id: "achievement_brick_32034_50000",
  title: "Axle Pin Connector Master",
  description: "Collect 50,000 Axle Pin Connector",
  category: "brick",
  targetType: "specific",
  targetId: "32034",
  threshold: 50000,
};

export const Achievement_Brick_3648_100: AchievementInfo = {
  id: "achievement_brick_3648_100",
  title: "Gear 24 Tooth Novice",
  description: "Collect 100 Gear 24 Tooth",
  category: "brick",
  targetType: "specific",
  targetId: "3648",
  threshold: 100,
};

export const Achievement_Brick_3648_1000: AchievementInfo = {
  id: "achievement_brick_3648_1000",
  title: "Gear 24 Tooth Collector",
  description: "Collect 1,000 Gear 24 Tooth",
  category: "brick",
  targetType: "specific",
  targetId: "3648",
  threshold: 1000,
};

export const Achievement_Brick_3648_10000: AchievementInfo = {
  id: "achievement_brick_3648_10000",
  title: "Gear 24 Tooth Expert",
  description: "Collect 10,000 Gear 24 Tooth",
  category: "brick",
  targetType: "specific",
  targetId: "3648",
  threshold: 10000,
};

export const Achievement_Brick_3648_50000: AchievementInfo = {
  id: "achievement_brick_3648_50000",
  title: "Gear 24 Tooth Master",
  description: "Collect 50,000 Gear 24 Tooth",
  category: "brick",
  targetType: "specific",
  targetId: "3648",
  threshold: 50000,
};

export const Achievement_Brick_3736_100: AchievementInfo = {
  id: "achievement_brick_3736_100",
  title: "Steering Pulley Novice",
  description: "Collect 100 Steering Pulley",
  category: "brick",
  targetType: "specific",
  targetId: "3736",
  threshold: 100,
};

export const Achievement_Brick_3736_1000: AchievementInfo = {
  id: "achievement_brick_3736_1000",
  title: "Steering Pulley Collector",
  description: "Collect 1,000 Steering Pulley",
  category: "brick",
  targetType: "specific",
  targetId: "3736",
  threshold: 1000,
};

export const Achievement_Brick_3736_10000: AchievementInfo = {
  id: "achievement_brick_3736_10000",
  title: "Steering Pulley Expert",
  description: "Collect 10,000 Steering Pulley",
  category: "brick",
  targetType: "specific",
  targetId: "3736",
  threshold: 10000,
};

export const Achievement_Brick_3736_50000: AchievementInfo = {
  id: "achievement_brick_3736_50000",
  title: "Steering Pulley Master",
  description: "Collect 50,000 Steering Pulley",
  category: "brick",
  targetType: "specific",
  targetId: "3736",
  threshold: 50000,
};

export const Achievement_Brick_32168_100: AchievementInfo = {
  id: "achievement_brick_32168_100",
  title: "Throwbot Arm Novice",
  description: "Collect 100 Throwbot Arm",
  category: "brick",
  targetType: "specific",
  targetId: "32168",
  threshold: 100,
};

export const Achievement_Brick_32168_1000: AchievementInfo = {
  id: "achievement_brick_32168_1000",
  title: "Throwbot Arm Collector",
  description: "Collect 1,000 Throwbot Arm",
  category: "brick",
  targetType: "specific",
  targetId: "32168",
  threshold: 1000,
};

export const Achievement_Brick_32168_10000: AchievementInfo = {
  id: "achievement_brick_32168_10000",
  title: "Throwbot Arm Expert",
  description: "Collect 10,000 Throwbot Arm",
  category: "brick",
  targetType: "specific",
  targetId: "32168",
  threshold: 10000,
};

export const Achievement_Brick_32168_50000: AchievementInfo = {
  id: "achievement_brick_32168_50000",
  title: "Throwbot Arm Master",
  description: "Collect 50,000 Throwbot Arm",
  category: "brick",
  targetType: "specific",
  targetId: "32168",
  threshold: 50000,
};

export const Achievement_Brick_3898_100: AchievementInfo = {
  id: "achievement_brick_3898_100",
  title: "Chef Hat Novice",
  description: "Collect 100 Chef Hat",
  category: "brick",
  targetType: "specific",
  targetId: "3898",
  threshold: 100,
};

export const Achievement_Brick_3898_1000: AchievementInfo = {
  id: "achievement_brick_3898_1000",
  title: "Chef Hat Collector",
  description: "Collect 1,000 Chef Hat",
  category: "brick",
  targetType: "specific",
  targetId: "3898",
  threshold: 1000,
};

export const Achievement_Brick_3898_10000: AchievementInfo = {
  id: "achievement_brick_3898_10000",
  title: "Chef Hat Expert",
  description: "Collect 10,000 Chef Hat",
  category: "brick",
  targetType: "specific",
  targetId: "3898",
  threshold: 10000,
};

export const Achievement_Brick_3898_50000: AchievementInfo = {
  id: "achievement_brick_3898_50000",
  title: "Chef Hat Master",
  description: "Collect 50,000 Chef Hat",
  category: "brick",
  targetType: "specific",
  targetId: "3898",
  threshold: 50000,
};

export const Achievement_Brick_30202_100: AchievementInfo = {
  id: "achievement_brick_30202_100",
  title: "Underwater Helmet Novice",
  description: "Collect 100 Underwater Helmet",
  category: "brick",
  targetType: "specific",
  targetId: "30202",
  threshold: 100,
};

export const Achievement_Brick_30202_1000: AchievementInfo = {
  id: "achievement_brick_30202_1000",
  title: "Underwater Helmet Collector",
  description: "Collect 1,000 Underwater Helmet",
  category: "brick",
  targetType: "specific",
  targetId: "30202",
  threshold: 1000,
};

export const Achievement_Brick_30202_10000: AchievementInfo = {
  id: "achievement_brick_30202_10000",
  title: "Underwater Helmet Expert",
  description: "Collect 10,000 Underwater Helmet",
  category: "brick",
  targetType: "specific",
  targetId: "30202",
  threshold: 10000,
};

export const Achievement_Brick_30202_50000: AchievementInfo = {
  id: "achievement_brick_30202_50000",
  title: "Underwater Helmet Master",
  description: "Collect 50,000 Underwater Helmet",
  category: "brick",
  targetType: "specific",
  targetId: "30202",
  threshold: 50000,
};

export const Achievement_Brick_x164_100: AchievementInfo = {
  id: "achievement_brick_x164_100",
  title: "Rebel Pilot Helmet Novice",
  description: "Collect 100 Rebel Pilot Helmet",
  category: "brick",
  targetType: "specific",
  targetId: "x164",
  threshold: 100,
};

export const Achievement_Brick_x164_1000: AchievementInfo = {
  id: "achievement_brick_x164_1000",
  title: "Rebel Pilot Helmet Collector",
  description: "Collect 1,000 Rebel Pilot Helmet",
  category: "brick",
  targetType: "specific",
  targetId: "x164",
  threshold: 1000,
};

export const Achievement_Brick_x164_10000: AchievementInfo = {
  id: "achievement_brick_x164_10000",
  title: "Rebel Pilot Helmet Expert",
  description: "Collect 10,000 Rebel Pilot Helmet",
  category: "brick",
  targetType: "specific",
  targetId: "x164",
  threshold: 10000,
};

export const Achievement_Brick_x164_50000: AchievementInfo = {
  id: "achievement_brick_x164_50000",
  title: "Rebel Pilot Helmet Master",
  description: "Collect 50,000 Rebel Pilot Helmet",
  category: "brick",
  targetType: "specific",
  targetId: "x164",
  threshold: 50000,
};

export const Achievement_Brick_3485_100: AchievementInfo = {
  id: "achievement_brick_3485_100",
  title: "Witch Hat Novice",
  description: "Collect 100 Witch Hat",
  category: "brick",
  targetType: "specific",
  targetId: "3485",
  threshold: 100,
};

export const Achievement_Brick_3485_1000: AchievementInfo = {
  id: "achievement_brick_3485_1000",
  title: "Witch Hat Collector",
  description: "Collect 1,000 Witch Hat",
  category: "brick",
  targetType: "specific",
  targetId: "3485",
  threshold: 1000,
};

export const Achievement_Brick_3485_10000: AchievementInfo = {
  id: "achievement_brick_3485_10000",
  title: "Witch Hat Expert",
  description: "Collect 10,000 Witch Hat",
  category: "brick",
  targetType: "specific",
  targetId: "3485",
  threshold: 10000,
};

export const Achievement_Brick_3485_50000: AchievementInfo = {
  id: "achievement_brick_3485_50000",
  title: "Witch Hat Master",
  description: "Collect 50,000 Witch Hat",
  category: "brick",
  targetType: "specific",
  targetId: "3485",
  threshold: 50000,
};

export const Achievement_Brick_x52_100: AchievementInfo = {
  id: "achievement_brick_x52_100",
  title: "Scout Trooper Helmet Novice",
  description: "Collect 100 Scout Trooper Helmet",
  category: "brick",
  targetType: "specific",
  targetId: "x52",
  threshold: 100,
};

export const Achievement_Brick_x52_1000: AchievementInfo = {
  id: "achievement_brick_x52_1000",
  title: "Scout Trooper Helmet Collector",
  description: "Collect 1,000 Scout Trooper Helmet",
  category: "brick",
  targetType: "specific",
  targetId: "x52",
  threshold: 1000,
};

export const Achievement_Brick_x52_10000: AchievementInfo = {
  id: "achievement_brick_x52_10000",
  title: "Scout Trooper Helmet Expert",
  description: "Collect 10,000 Scout Trooper Helmet",
  category: "brick",
  targetType: "specific",
  targetId: "x52",
  threshold: 10000,
};

export const Achievement_Brick_x52_50000: AchievementInfo = {
  id: "achievement_brick_x52_50000",
  title: "Scout Trooper Helmet Master",
  description: "Collect 50,000 Scout Trooper Helmet",
  category: "brick",
  targetType: "specific",
  targetId: "x52",
  threshold: 50000,
};

export const Achievement_Brick_2528_100: AchievementInfo = {
  id: "achievement_brick_2528_100",
  title: "Pirate Hat Novice",
  description: "Collect 100 Pirate Hat",
  category: "brick",
  targetType: "specific",
  targetId: "2528",
  threshold: 100,
};

export const Achievement_Brick_2528_1000: AchievementInfo = {
  id: "achievement_brick_2528_1000",
  title: "Pirate Hat Collector",
  description: "Collect 1,000 Pirate Hat",
  category: "brick",
  targetType: "specific",
  targetId: "2528",
  threshold: 1000,
};

export const Achievement_Brick_2528_10000: AchievementInfo = {
  id: "achievement_brick_2528_10000",
  title: "Pirate Hat Expert",
  description: "Collect 10,000 Pirate Hat",
  category: "brick",
  targetType: "specific",
  targetId: "2528",
  threshold: 10000,
};

export const Achievement_Brick_2528_50000: AchievementInfo = {
  id: "achievement_brick_2528_50000",
  title: "Pirate Hat Master",
  description: "Collect 50,000 Pirate Hat",
  category: "brick",
  targetType: "specific",
  targetId: "2528",
  threshold: 50000,
};

export const Achievement_Brick_3624_100: AchievementInfo = {
  id: "achievement_brick_3624_100",
  title: "Police Hat Novice",
  description: "Collect 100 Police Hat",
  category: "brick",
  targetType: "specific",
  targetId: "3624",
  threshold: 100,
};

export const Achievement_Brick_3624_1000: AchievementInfo = {
  id: "achievement_brick_3624_1000",
  title: "Police Hat Collector",
  description: "Collect 1,000 Police Hat",
  category: "brick",
  targetType: "specific",
  targetId: "3624",
  threshold: 1000,
};

export const Achievement_Brick_3624_10000: AchievementInfo = {
  id: "achievement_brick_3624_10000",
  title: "Police Hat Expert",
  description: "Collect 10,000 Police Hat",
  category: "brick",
  targetType: "specific",
  targetId: "3624",
  threshold: 10000,
};

export const Achievement_Brick_3624_50000: AchievementInfo = {
  id: "achievement_brick_3624_50000",
  title: "Police Hat Master",
  description: "Collect 50,000 Police Hat",
  category: "brick",
  targetType: "specific",
  targetId: "3624",
  threshold: 50000,
};

export const Achievement_Brick_30325_100: AchievementInfo = {
  id: "achievement_brick_30325_100",
  title: "Mining Helmet Novice",
  description: "Collect 100 Mining Helmet",
  category: "brick",
  targetType: "specific",
  targetId: "30325",
  threshold: 100,
};

export const Achievement_Brick_30325_1000: AchievementInfo = {
  id: "achievement_brick_30325_1000",
  title: "Mining Helmet Collector",
  description: "Collect 1,000 Mining Helmet",
  category: "brick",
  targetType: "specific",
  targetId: "30325",
  threshold: 1000,
};

export const Achievement_Brick_30325_10000: AchievementInfo = {
  id: "achievement_brick_30325_10000",
  title: "Mining Helmet Expert",
  description: "Collect 10,000 Mining Helmet",
  category: "brick",
  targetType: "specific",
  targetId: "30325",
  threshold: 10000,
};

export const Achievement_Brick_30325_50000: AchievementInfo = {
  id: "achievement_brick_30325_50000",
  title: "Mining Helmet Master",
  description: "Collect 50,000 Mining Helmet",
  category: "brick",
  targetType: "specific",
  targetId: "30325",
  threshold: 50000,
};

export const Achievement_Brick_30167_100: AchievementInfo = {
  id: "achievement_brick_30167_100",
  title: "Wide Brim Hat Novice",
  description: "Collect 100 Wide Brim Hat",
  category: "brick",
  targetType: "specific",
  targetId: "30167",
  threshold: 100,
};

export const Achievement_Brick_30167_1000: AchievementInfo = {
  id: "achievement_brick_30167_1000",
  title: "Wide Brim Hat Collector",
  description: "Collect 1,000 Wide Brim Hat",
  category: "brick",
  targetType: "specific",
  targetId: "30167",
  threshold: 1000,
};

export const Achievement_Brick_30167_10000: AchievementInfo = {
  id: "achievement_brick_30167_10000",
  title: "Wide Brim Hat Expert",
  description: "Collect 10,000 Wide Brim Hat",
  category: "brick",
  targetType: "specific",
  targetId: "30167",
  threshold: 10000,
};

export const Achievement_Brick_30167_50000: AchievementInfo = {
  id: "achievement_brick_30167_50000",
  title: "Wide Brim Hat Master",
  description: "Collect 50,000 Wide Brim Hat",
  category: "brick",
  targetType: "specific",
  targetId: "30167",
  threshold: 50000,
};

export const Achievement_Brick_30381_100: AchievementInfo = {
  id: "achievement_brick_30381_100",
  title: "Hood Novice",
  description: "Collect 100 Hood",
  category: "brick",
  targetType: "specific",
  targetId: "30381",
  threshold: 100,
};

export const Achievement_Brick_30381_1000: AchievementInfo = {
  id: "achievement_brick_30381_1000",
  title: "Hood Collector",
  description: "Collect 1,000 Hood",
  category: "brick",
  targetType: "specific",
  targetId: "30381",
  threshold: 1000,
};

export const Achievement_Brick_30381_10000: AchievementInfo = {
  id: "achievement_brick_30381_10000",
  title: "Hood Expert",
  description: "Collect 10,000 Hood",
  category: "brick",
  targetType: "specific",
  targetId: "30381",
  threshold: 10000,
};

export const Achievement_Brick_30381_50000: AchievementInfo = {
  id: "achievement_brick_30381_50000",
  title: "Hood Master",
  description: "Collect 50,000 Hood",
  category: "brick",
  targetType: "specific",
  targetId: "30381",
  threshold: 50000,
};
